import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import '../dialog/dialog';
import { MainViewModel } from "../../main";
import { Utils } from "../../utils";
import { Postbox } from "../postbox/postbox";
import moment = require("moment");
import { RolesAndRights } from "../../helpers/RolesAndRights";
import {observableArray} from "knockout";

export class SettingsViewModel {
    deleteModalTitle = ko.observable("");
    deleteModalText = ko.observable("");
    temp = ko.observable("");
    error = ko.observable("");
    IsStandard = ko.observable(false);
    TextHeaderName = ko.observable("");
    fristModalTitle = ko.observable("FRISTGRUND ANLEGEN");
    referatModalTitle = ko.observable("NEUES REFERAT");
    rachtsModalTitle = ko.observable("NEUE RECHTSFORM");
    referateStatus = ko.observable(true);
    weiderStatus = ko.observable(true);
    fristStatus = ko.observable(true);
    rachtsStatus = ko.observable(true);
    yesDelete = ko.observable(false);
    lockStatus = ko.observable(false);
    users = ko.observableArray([]);
    anreden = ko.observableArray(['', 'Frau', 'Frau Dr.', 'Herr', 'Herr Dr.', 'Dr.', 'Prof.', 'Prof. Dr.']);
    rollen = ko.observableArray(['Anwalt', 'ReFa', 'PA / Sekretariat', 'Administrator', 'Viewer']);
    inboxes = ko.observableArray([]);
    filterType = ko.observable('email');
    bl = ko.observable(false);
    hasAutomationModule = ko.observable<boolean>(false);
    hasVerificationRights = ko.observable(false);
    hasInboxModule = ko.observable<boolean>(false);
    locationOptions = ko.observableArray([]);
    HourlyMoney = ko.observable();
    filteredInboxes: ko.Computed<any>;
    allStandorte = ko.observableArray([]);
    allFKA = ko.observableArray([]);
    allInstances = ko.observableArray([]);
    allInboxes = ko.observableArray([]);
    allGerichtAddresses = ko.observableArray([]);
    allDeadlineExtensionReasons = ko.observableArray([]);
    allMakros = ko.observableArray([]);
    DeadlineExtensionReason = ko.observable('');
    statusModalTitle = ko.observable("");
    mailAppend = ko.observable("@gmail.com");
    cityName = ko.observable("");
    emailID = ko.observable("");
    mailModalTitle = ko.observable("");
    statusModalText = ko.observable("");
    statusText = ko.observable("");
    statusVisible = ko.observable(false);
    hasError = ko.observable(false);
    currentUserSymbol = ko.observable();
    units = ko.observableArray([]);
    legalforms = ko.observableArray([]);
    documentData = null;
    reasons = ko.observableArray([]);
    fristReasons = ko.observableArray([]);
    deadlineReasons = ko.observableArray([]);
    referatResult = ko.observable("");
    lawfirmDataNew = ko.observable({
        LawFirmName: ko.observable(""),
        Adresszusatz: ko.observable(""),
        LawfirmName: ko.observable(""),
        Ort: ko.observable(""),
        Postleitzahl: ko.observable(""),
        SoldanKundennummer: ko.observable(""),
        Strasse: ko.observable(""),
        Website: ko.observable("")
    })
    lawFirmData = ko.observable({
        LawFirmName: ko.observable(""),
        Address: ko.observable(""),
        AdditionalAddress: ko.observable(""),
        PostCode: ko.observable(""),
        Place: ko.observable(""),
        Website: ko.observable(""),
        FormOfAddress: ko.observable(""),
        Firstname: ko.observable(""),
        Lastname: ko.observable(""),
        Phone: ko.observable(""),
        Mail: ko.observable(""),
        LawFirmId: ko.observable(""),
        Username: ko.observable(""),
        Password: ko.observable(""),
        PasswordRetry: ko.observable(""),
        SoldanMail: ko.observable(""),
        SoldanPassword: ko.observable(""),
        UserRole: ko.observable(""),
        RoleName: ko.observable(""),
        Title: ko.observable(""),
        Mobile: ko.observable(""),
        IsLocked: ko.observable(false),
        isAdmin: ko.observable(false),
        SafeId: ko.observable(""),
        LocationId: ko.observable("")
    });
    lawFirmAbonnementData = ko.observable({
        SEPAError: ko.observable(false),
        Kreditinstitut: ko.observable(''),
        Kontoinhaber: ko.observable(''),
        BIC: ko.observable(''),
        IBAN: ko.observable(''),
        ExternalFlagNumber: ko.observable(''),
        ExternalFlagActive: ko.observable(false),
        ExternalErrorMessage: ko.observable(''),
        Produkt: ko.observable(''),
        StandardVersion: ko.observable(false)
    });
    initalVersion = ko.observable("Testversion");
    showSEPA = ko.observable(false);
    isSoldanPrintVersion = ko.observable<boolean>(false);
    showSoldanPrintVersion = ko.observable<boolean>(false);
    changeProductSuccess = ko.observable<boolean>(false);
    changeProductError = ko.observable<boolean>(false);
    submitSubscribeSoldanFristenmodul = ko.observable<boolean>(false);
    showSEPAError = ko.observable(false);
    transmittSEPAError = ko.observable(false);
    transmittSEPASucce = ko.observable(false);
    enableConsultant = ko.observable(false);
    userInformation: any = ko.observable({});
    lawFirmDetails = ko.observable({});
    providersList: ko.ObservableArray<string> = ko.observableArray(["GMail", "GMX", "T-Online", "Me", "Web", "Domainfactory", "Yahoo", "AOL", "Andere"]);
    deleteDataValue = ko.observable("");
    newMailUser = ko.observable(false);
    IN_Proto = ko.observable("");
    showUserError = ko.observable("");
    base64Content = ko.observable("");
    expirationTime = ko.observable("W");
    expirationTimeF = ko.observable("w");
    durations = ['D', 'W', 'M', 'J'];
    durationsSinglar = ['Tag', 'Woche', 'Monat', 'Jahr'];
    durationsPlural = ['Tage', 'Wochen', 'Monate', 'Jahre'];
    FileName = ko.observable("");
    hasRightsForStandorte = ko.observable(false);
    testAboEnd = ko.observable("");
    aboAlert = ko.observable(false);
    standLawfirmID = ko.observable("");
    standUserID = ko.observable("");
    standPassword = ko.observable("");
    createDeadlineReason = ko.observable(true);
    useOAuth_Creation = ko.observable(false);
    useOAuth_Inbox = ko.observable(false);
    editFKA = ko.observable(false);
    editInbox = ko.observable(false);
    editInstanceId = ko.observable("");
    editInstanceName = ko.observable("");
    hasKanzleiImage = ko.observable(false);
    editCourt = ko.observable(false);
    Ger_Name = ko.observable("");
    Ger_City = ko.observable("");
    Ger_Keyword = ko.observable("");
    Ger_Mail = ko.observable("");
    Ger_Phone = ko.observable("");
    Ger_Postcode = ko.observable("");
    Ger_Street = ko.observable("");
    Ger_State = ko.observable(0);
    Ger_SafeId = ko.observable("");
    Edit_Ger_Keyword = ko.observable("");
    Edit_Ger_State = ko.observable(0);
    createInstanceName = ko.observable("");
    assignedUserCases = ko.observable([]);
    EWSURL = ko.observable("");
    UserLogin = ko.observable("");
    UserPassword = ko.observable("");
    OutlookAccountID = ko.observable("");
    OAuthClientId = ko.observable("");
    OAuthClientSecret = ko.observable("");
    ImapHost = ko.observable("");
    Login = ko.observable("");
    BasicPassword = ko.observable("");
    OAuthTenant = ko.observable("");
    ClientId = ko.observable("");
    ClientSecret = ko.observable("");
    MailAccountID = ko.observable("");
    LocationId = ko.observable("");
    uploadAccountImageError = ko.observable("");
    statesTable = {
        0: "Nicht definiert",
        2: "Baden-Württemberg",
        3: "Bayern (EV)",
        4: "Bayern (RK)",
        5: "Berlin",
        6: "Brandenburg",
        7: "Bremen",
        8: "Hamburg",
        9: "Hessen",
        10: "Mecklenburg-Vorpommern",
        11: "Niedersachsen",
        12: "Nordrhein-Westfalen",
        13: "Rheinland-Pfalz",
        14: "Saarland",
        15: "Sachsen",
        16: "Sachsen-Anhalt",
        17: "Schleswig Holstein",
        18: "Thüringen (EV)",
        19: "Thüringen (RK)"
    };
    isLicenseExpired = ko.observable<boolean>(false);
    addLicenseExpiredInfo = ko.observable<boolean>(false);
    currentId = ko.observable(null);
    wopiToken = {
        "AccessToken": "",
        "AccessTokenTtl": 0
    };
    currentMimeType = ko.observable(null);
    executeSaveUserProfileLoader = ko.observable(false);
    userPassword = ko.observable("");
    passwordError = ko.observable("");
    appointmentModalTitle = ko.observable("Terminart anlegen");
    appointmentTypes = ko.observableArray([]);
    appointmentTypesForMakros = ko.observableArray([]);
    createAppointmentType = ko.observable(true);
    submitExternalFlagData() {
        if (this.lawFirmAbonnementData().ExternalFlagNumber.length > 2) {
            this.lawFirmAbonnementData().ExternalErrorMessage(ko.toJS('Ungültige Consultant-ID.'));
        }
        else {
            this.lawFirmAbonnementData().ExternalErrorMessage(ko.toJS(''));
        }
    }
    submitLawFirmSEPAData() {
        this.submitExternalFlagData();
        if (this.lawFirmAbonnementData().ExternalErrorMessage() === ko.toJS("")) {
            if (this.lawFirmAbonnementData().Kreditinstitut() !== ko.toJS("") && this.lawFirmAbonnementData().Kontoinhaber() !== ko.toJS("") && this.lawFirmAbonnementData().IBAN() !== ko.toJS("") && this.lawFirmAbonnementData().BIC() !== ko.toJS("")) {
                this.showSEPAError(false);
                this.saveLawFirmAbonnementData();
            }
            else {
                this.showSEPAError(true);
            }
        }
    }
    selectSoldanPrintVersion(data, event) {
        this.isSoldanPrintVersion(event.target.checked);
    }
    async subscribeSoldanFristenmodul() {
        if (this.lawFirmAbonnementData().Produkt.toString() !== null || this.lawFirmAbonnementData().Produkt.toString() !== "") {
            if (this.submitSubscribeSoldanFristenmodul())
                return;
            this.submitSubscribeSoldanFristenmodul(true);
            await RNSAPI.changeProduct({ Product: this.lawFirmAbonnementData().Produkt.toString(), PaperDeadlineCalendar: this.isSoldanPrintVersion() ? 1 : 0 }).then((response) => {
                this.changeProductSuccess(true);
                this.changeProductError(false);
                this.submitSubscribeSoldanFristenmodul(false);
            }, error => {
                this.changeProductError(true);
                this.changeProductSuccess(false);
                this.submitSubscribeSoldanFristenmodul(false);
            });
        }
    }
    async getKanzleiImage() {
        await RNSAPI.getAccountImage().then((data) => {
            let res = data as any;
            if (res)
                this.hasKanzleiImage(true);
        }).catch((error) => {
            this.hasKanzleiImage(false);
        });
    }
    async loadLawFirmAbonnementData() {
        const result = await RNSAPI.getLawFirmAbonnementData();
        if (result.Type === "GetAbonnementDataResult") {
            this.lawFirmAbonnementData(result.Payload.Data);
            this.initalVersion(ko.toJS(this.lawFirmAbonnementData().Produkt));
            if (ko.toJS(this.lawFirmAbonnementData().Produkt) === "Standard" || ko.toJS(this.lawFirmAbonnementData().Produkt) === "Verification") {
                this.lawFirmAbonnementData().StandardVersion = ko.observable<boolean>(true);
                this.showSEPA(true);
            }
            else {
                let end = moment(result.Payload.Data.TestAboEnd).format("DD.MM.YYYY");
                this.testAboEnd(end);
                if (moment(result.Payload.Data.TestAboEnd).format("YYYYMMDD") < moment(moment.now()).format("YYYYMMDD")) {
                    this.aboAlert(true);
                }
            }
            if (ko.toJS(this.lawFirmAbonnementData().ExternalFlagNumber) !== "0") {
                this.lawFirmAbonnementData().ExternalFlagActive = ko.observable<boolean>(true);
            }
        }
    }
    switchProduct(data, event) {
        this.lawFirmAbonnementData().Produkt = event.target.value;
        if (this.lawFirmAbonnementData().Produkt.toString() === 'Testversion') {
            this.showSEPA(false);
            this.showSoldanPrintVersion(false);
            return;
        }
        this.showSEPA(true);
        this.showSoldanPrintVersion(true);
    }
    async saveLawFirmAbonnementData() {
        let res = await RNSAPI.saveLawFirmAbonnementData({
            Kreditinstitut: this.lawFirmAbonnementData().Kreditinstitut,
            Kontoinhaber: this.lawFirmAbonnementData().Kontoinhaber,
            BIC: this.lawFirmAbonnementData().BIC,
            IBAN: this.lawFirmAbonnementData().IBAN,
            ExternalFlagNumber: this.lawFirmAbonnementData().ExternalFlagNumber,
            Produkt: this.lawFirmAbonnementData().Produkt
        });
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if (res.Type === "UpdateAbonnementSuccessful") {
            this.transmittSEPAError(false);
            this.transmittSEPASucce(true);
            if (this.isLicenseExpired()) {
                this.addLicenseExpiredInfo(true);
            }
        }
        else {
            this.transmittSEPASucce(false);
            this.transmittSEPAError(true);
        }
    }
    async uploadAccountImage(file: any) {
        if (file) {
            const fileExtension = file.name.split('.').pop();
            if (['jpg', 'png', 'gif'].indexOf(fileExtension.toLowerCase()) == -1)
                return this.uploadAccountImageError('<i class="fas fa-exclamation-triangle"></i> Ung&uuml;ltiges Bild-Format.');
            if (file.size <= 1000000) {
                const formData = new FormData();
                formData.append("accountImage", file);
                formData.append("fileExtension", fileExtension);
                await RNSAPI.uploadAccountImage(formData).then((data) => {
                    Postbox.publisher().publish(true, "RefreshLawFirmImage");
                    this.uploadAccountImageError("");
                    this.hasKanzleiImage(true);
                }).catch((error) => {
                    this.uploadAccountImageError('<i class="fas fa-exclamation-triangle"></i> Fehler beim Hochladen.');
                });
            }
            else {
                this.uploadAccountImageError('<i class="fas fa-exclamation-triangle"></i> Das Kanzleibild ist zu groß. (Max. 1 MB)');
            }
        }
    }
    async removeLawfirmImage() {
        await RNSAPI.removeAccountImage().then((data) => {
            Postbox.publisher().publish(true, "RefreshLawFirmImage");
            this.uploadAccountImageError("");
            this.hasKanzleiImage(false);
        }).catch((error) => {
            this.uploadAccountImageError('<i class="fas fa-exclamation-triangle"></i> Fehler beim Entfernen.');
        });
    }
    providers() {
        let obj = {
            name: ko.observable(""),
            in: ko.observableArray([]),
            out: ko.observable(""),
            imapPort: ko.observable(""),
            pop3Port: ko.observable(""),
            smtp: ko.observableArray([]),
            encryption: ko.observableArray([])
        };
        this.mailAppend("@gmail.com");
        return ko.observable(obj);
    }
    provider = this.providers();
    selectProtocol() {
        if (ko.toJS(this.IN_Proto()) == "POP3") {
            this.inbox().IN_ProtokollType(0);
            this.inbox().IN_Port(ko.toJS(this.provider().pop3Port()));
            if (ko.toJS(this.provider().name) == "Domainfactory") {
                this.inbox().IN_Host(ko.toJS(this.provider().in()[0].toString()));
            }
            else {
                this.inbox().IN_Host(ko.toJS(this.provider().in()[1]));
            }
        }
        else {
            this.inbox().IN_ProtokollType(1);
            this.inbox().IN_Port(ko.toJS(this.provider().imapPort()));
            this.inbox().IN_Host(ko.toJS(this.provider().in()[0]));
        }
    }
    async cityFilter() {
        let result = await RNSAPI.getPostcode(this.lawFirmData().PostCode());
        if (result.Type == "GetPostcodeResult" && result.Payload.Cities.length > 0) {
            this.lawFirmData().Place = result.Payload.Cities[0];
            this.cityName(result.Payload.Cities[0]);
        }
        else {
            this.cityName("");
        }
    }
    selectOption() {
        this.newMailUser(false);
        this.mailModalTitle(ko.toJS(this.provider().name));
        if (ko.toJS(this.provider().name) == "Domainfactory") {
            this.provider().in(["sslin.df.eu"]);
            this.provider().out("sslout.df.eu");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["465"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@df.eu");
        }
        else if (ko.toJS(this.provider().name) == "GMail") {
            this.provider().in(["imap.gmail.com", "pop.gmail.com",]);
            this.provider().out("smtp.gmail.com");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["587", "465"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@gmail.com");
        }
        else if (ko.toJS(this.provider().name) == "Yahoo") {
            this.provider().in(["imap.mail.yahoo.com", "pop.mail.yahoo.com"]);
            this.provider().out("imap.mail.yahoo.com ");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["465"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@yahoo.com ");
        }
        else if (ko.toJS(this.provider().name) == "AOL") {
            this.provider().in(["imap.de.aol.com", "pop.aol.com"]);
            this.provider().out("smtp.de.aol.com");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["465"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@df.eu");
        }
        else if (ko.toJS(this.provider().name) == "Web") {
            this.provider().in(["imap.web.de", "pop3.web.de"]);
            this.provider().out("smtp.web.de");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["465"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@web.de");
        }
        else if (ko.toJS(this.provider().name) == "GMX") {
            this.provider().in(["imap.gmx.net", "pop.gmx.net"]);
            this.provider().out("mail.gmx.net");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["587"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@gmx.net");
        }
        else if (ko.toJS(this.provider().name) == "T-Online") {
            this.provider().in(["secureimap.t-online.de", "securepop.t-online.de "]);
            this.provider().out("securesmtp.t-online.de");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["465"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@t-online.de");
        }
        else if (ko.toJS(this.provider().name) == "Me") {
            this.provider().in(["imap.mail.me.com"]);
            this.provider().out("smtp.mail.me.com");
            this.provider().imapPort("993");
            this.provider().pop3Port("995");
            this.provider().smtp(["587"]);
            this.provider().encryption(["SSL", "TLS"]);
            this.mailAppend("@me.com");
        }
        else if (ko.toJS(this.provider().name) == "Andere") {
            this.newMailUser(true);
            this.mailAppend("");
        }
        this.inbox().OUT_Host(ko.toJS(this.provider().out()));
        this.inbox().IN_ProtokollType(0);
        this.inbox().IN_Port(ko.toJS(this.provider().pop3Port()));
        if (ko.toJS(this.newMailUser())) {
            this.mailModalTitle("Neuer Account");
        }
    }
    providerAccounts() {
        let account = {
            uname: ko.observable(""),
            email: ko.observable(""),
            password: ko.observable("")
        };
        return ko.observable(account);
    }
    accounts = this.providerAccounts();
    async addFKA() {
        if (ko.toJS(this.editFKA)) {
            let res = (await RNSAPI.updateOutlook(ko.toJS(this.EWSURL), ko.toJS(this.UserLogin), ko.toJS(this.UserPassword), ko.toJS(this.useOAuth_Creation), ko.toJS(this.OutlookAccountID), ko.toJS(this.OAuthClientId), ko.toJS(this.OAuthClientSecret)));
            if (res.Type === "UpdateAccountSuccessful") {
                this.EWSURL("");
                this.UserLogin("");
                this.UserPassword("");
                this.OutlookAccountID("");
                this.OAuthClientId("");
                this.OAuthClientSecret("");
                $("#newFKA").modal("hide");
                this.getFKA();
                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                this.statusModalText('Die Adresse wurde erfolgreich bearbeitet.');
                $("#statusModal").modal('show');
            }
            else {
                $("#newFKA").modal("hide");
                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler');
                this.statusModalText('Die Adresse konnte nicht editiert werden. Bitte prüfen Sie Ihre Eingaben.');
                $("#statusModal").modal('show');
            }
        }
        else {
            let res = (await RNSAPI.addOutlook(ko.toJS(this.EWSURL), ko.toJS(this.UserLogin), ko.toJS(this.UserPassword), ko.toJS(this.useOAuth_Creation), ko.toJS(this.OAuthClientId), ko.toJS(this.OAuthClientSecret)));
            if (res.Type === "AddAccountSuccessful") {
                this.EWSURL("");
                this.UserLogin("");
                this.UserPassword("");
                this.OAuthClientId("");
                this.OAuthClientSecret("");
                $("#newFKA").modal("hide");
                this.getFKA();
                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                this.statusModalText('Die Adresse wurde erfolgreich hinzugefügt.');
                $("#statusModal").modal('show');
            }
            else {
                $("#newFKA").modal("hide");
                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler');
                this.statusModalText('Die Adresse konnte nicht hinterlegt werden. Bitte prüfen Sie Ihre Eingaben.');
                $("#statusModal").modal('show');
            }
        }
    }
    async addInbox() {
        if (ko.toJS(this.editInbox)) {
            let res = (await RNSAPI.updateMailInbox(ko.toJS(this.ImapHost), ko.toJS(this.Login), ko.toJS(this.BasicPassword), ko.toJS(this.useOAuth_Inbox), ko.toJS(this.LocationId), ko.toJS(this.MailAccountID), ko.toJS(this.ClientId), ko.toJS(this.ClientSecret), ko.toJS(this.OAuthTenant)));
            if (res.Type === "UpdateAccountSuccessful") {
                this.ImapHost("");
                this.Login("");
                this.BasicPassword("");
                this.LocationId("");
                this.ClientId("");
                this.ClientSecret("");
                this.OAuthTenant("");
                $("#newInbox").modal("hide");
                this.getMailInboxes();
                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                this.statusModalText('Die Adresse wurde erfolgreich aktualisiert.');
                $("#statusModal").modal('show');
            }
            else {
                $("#newInbox").modal("hide");
                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler');
                this.statusModalText('Die Adresse konnte nicht hinterlegt werden. Bitte prüfen Sie Ihre Eingaben.');
                $("#statusModal").modal('show');
            }
        }
        else {
            let res = (await RNSAPI.addInbox(ko.toJS(this.ImapHost), ko.toJS(this.Login), ko.toJS(this.BasicPassword), ko.toJS(this.useOAuth_Inbox), ko.toJS(this.LocationId), ko.toJS(this.ClientId), ko.toJS(this.ClientSecret), ko.toJS(this.OAuthTenant)));
            if (res.Type === "AddAccountSuccessful") {
                this.ImapHost("");
                this.Login("");
                this.BasicPassword("");
                this.LocationId("");
                this.ClientId("");
                this.ClientSecret("");
                this.OAuthTenant("");
                this.MailAccountID("");
                $("#newInbox").modal("hide");
                this.getMailInboxes();
                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                this.statusModalText('Die Adresse wurde erfolgreich hinzugefügt.');
                $("#statusModal").modal('show');
            }
            else {
                $("#newInbox").modal("hide");
                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler');
                this.statusModalText('Die Adresse konnte nicht hinterlegt werden. Bitte prüfen Sie Ihre Eingaben.');
                $("#statusModal").modal('show');
            }
        }
    }
    openNewFKAModal() {
        this.editFKA(false);
        this.OutlookAccountID("");
        this.EWSURL("");
        this.UserLogin("");
        this.UserPassword("");
        this.useOAuth_Creation(false);
        this.OAuthClientId("");
        this.OAuthClientSecret("");
        $("#newFKA").modal("show");
    }
    openNewInboxModal() {
        this.editInbox(false);
        this.useOAuth_Inbox(false);
        this.ImapHost("");
        this.Login("");
        this.BasicPassword("");
        this.LocationId("");
        $("#newInbox").modal("show");
    }
    openNewInstanceModal() {
        this.createInstanceName("");
        $("#createInstance").modal("show");
    }
    openNewCourtModal() {
        this.Ger_City("");
        this.Ger_Postcode("");
        this.Ger_Name("");
        this.Ger_Keyword("");
        this.Ger_Street("");
        this.Ger_State(0);
        this.Ger_Mail("");
        this.Ger_Phone("");
        this.Ger_SafeId("");
        this.editCourt(false);
        $("#createCourt").modal("show");
    }
    openNewStandortModal() {
        this.standLawfirmID("");
        this.standUserID("");
        this.standPassword("");
        $("#newStandort").modal("show");
    }
    async assignNewStandort() {
        let res = (await RNSAPI.assignLocation(ko.toJS(this.standLawfirmID()), ko.toJS(this.standUserID), ko.toJS(this.standPassword)));
        if (res.Type === "AssignmentSuccessful") {
            this.standLawfirmID("");
            this.standUserID("");
            this.standPassword("");
            $("#newStandort").modal("hide");
            this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
            this.statusModalText('Der Standort wurde erfolgreich hinzugefügt.');
            $("#statusModal").modal('show');
            this.getStandorte();
        }
        else {
            switch (ko.toJS(res.Payload.Reason)) {
                case "0 - Access denied":
                    $("#newStandort").modal("hide");
                    this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Keine Berechtigung');
                    this.statusModalText('Sie sind nicht berechtigt einen Standort zu hinterlgen.');
                    $("#statusModal").modal('show');
                    break;
                case "1 - Lawfirm does not exist":
                    this.standLawfirmID("");
                    break;
                case "2 - Assignment already exists":
                    $("#newStandort").modal("hide");
                    this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Standort vorhanden');
                    this.statusModalText('Sie haben bereits Zugriff auf den eingegebenen Standort.');
                    $("#statusModal").modal('show');
                    break;
                case "3 - UserID or Password are incorrect":
                    this.standUserID("");
                    this.standPassword("");
                    break;
                default:
                    $("#newStandort").modal("hide");
                    this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehlerhafte Daten');
                    this.statusModalText('Sie haben fehlerhafte Daten eingegeben.');
                    $("#statusModal").modal('show');
            }
        }
    }
    openNewAccountModal() {
        this.accounts().uname("");
        this.accounts().email("");
        this.accounts().password("");
        this.clearInbox();
        this.clearProvider();
        this.currentView() == 'beA' ? this.isBeaProtocol(true) : this.isBeaProtocol(false);
        this.newMailUser(false);
        this.mailModalTitle(ko.toJS(this.provider().name));
        this.provider().in(["imap.gmail.com", "pop.gmail.com",]);
        this.provider().out("smtp.gmail.com");
        this.provider().imapPort("993");
        this.provider().pop3Port("995");
        this.provider().smtp(["587", "465"]);
        this.provider().encryption(["SSL", "TLS"]);
        this.mailAppend("@gmail.com");
        this.inbox().OUT_Host(ko.toJS(this.provider().out()));
        this.inbox().IN_ProtokollType(0);
        this.inbox().IN_Port(ko.toJS(this.provider().pop3Port()));
        if (ko.toJS(this.newMailUser())) {
            this.mailModalTitle("Neuer Account");
        }
        $(".accounts_auswahl_email").val("GMail");
        $('#accounts').modal('hide');
        $('#accounts').modal('show');
    }
    accountSave() {
        this.inbox().EMail_Address(ko.toJS(this.accounts().email) + this.mailAppend());
        this.inbox().IN_UserLogin(ko.toJS(this.accounts().email) + this.mailAppend());
        this.inbox().IN_UserPassword(ko.toJS(this.accounts().password));
        this.inbox().OUT_UserLogin(ko.toJS(this.accounts().email) + this.mailAppend());
        this.inbox().OUT_UserPassword(ko.toJS(this.accounts().password));
        this.inbox().OUT_Port(ko.toJS(this.provider().smtp()[0]));
        this.inbox().OUT_Host(ko.toJS(this.provider().out));
        this.selectProtocol();
        $("#createMail").modal('show');
        $("#accounts").modal('hide');
    }
    accountSaveBe() {
        this.inbox().EMail_Address(ko.toJS(this.accounts().email) + this.mailAppend());
        this.inbox().IN_UserLogin(ko.toJS(this.accounts().email) + this.mailAppend());
        this.inbox().IN_UserPassword(ko.toJS(this.accounts().password));
        this.inbox().OUT_UserLogin(ko.toJS(this.accounts().email) + this.mailAppend());
        this.inbox().OUT_UserPassword(ko.toJS(this.accounts().password));
        this.inbox().OUT_Port(ko.toJS(this.provider().smtp()[0]));
        this.inbox().OUT_Host(ko.toJS(this.provider().out));
        this.selectProtocol();
        $("#createMail").modal('show');
        $("#createBea").modal('hide');
    }
    newCreateUser() {
        let obj = {
            Anrede: ko.observable(null),
            Vorname: ko.observable(null),
            Nachname: ko.observable(null),
            Telefon: ko.observable("+49"),
            EMail: ko.observable(null),
            Rolle: ko.observable(null),
            Benutzer: ko.observable(null),
            Passwort: ko.observable(null),
            PasswortRetry: ko.observable(null),
            Recherche_EMail: ko.observable(""),
            Recherche_Passwort: ko.observable(""),
            Recherche_PasswortRetry: ko.observable(""),
            isAdmin: ko.observable(false),
            SafeId: ko.observable(""),
            LocationOptions:  ko.observableArray<{ Id: number; Name: string }>([]),
            SelectedLocationId: ko.observable(null)
        };
        return ko.observable(obj);
    };
    createUser = this.newCreateUser();
    newDeadlineReasons() {
        let obj = {
            DeadlineNumber: ko.observable(""),
            DeadlineDescription: ko.observable(""),
            DurationIntervall: ko.observable("1"),
            DurationAmount: ko.observable("2"),
            DeadlineVerifcation: ko.observable(false),
            DeadlineVerificationCompletion: ko.observable(false),
            IsEmergencyDeadline: ko.observable(false),
            CalculateLikePreDeadline: ko.observable(false),
            PreDeadlines: ko.observableArray([]),
            DeadlineDurationText: ko.observable("")
        };
        return ko.observable(obj);
    };
    deadlineReason = this.newDeadlineReasons();
    newAppointmentType() {
        let obj = {
            Id: ko.observable(0),
            Name: ko.observable(""),
            TypeId: ko.observable(""),
            SubjectSuggestion: ko.observable(""),
            Inactive: ko.observable(false),
            OutlookShowAsBusy: ko.observable(true),
            HasToBeVerified: ko.observable(false),
            IsAllDay: ko.observable(false),
        };
        return ko.observable(obj);
    };
    appointmentType = this.newAppointmentType();
    newRachtsform() {
        let obj = {
            Anrede: ko.observable(""),
            Briefanrede: ko.observable(""),
            NameID: ko.observable(""),
            AnredeForm: ko.observable(""),
            RechtsformType: ko.observable("")
        };
        return ko.observable(obj);
    };
    rachtsform = this.newRachtsform();
    newRefrate() {
        let obj = {
            referatName: ko.observable(""),
            referatId: ko.observable("")
        };
        return ko.observable(obj);
    };
    referat = this.newRefrate();
    EmailAdds = ko.observableArray([{
            Index: 0,
            beApost: ko.observable(''),
        }]);
    addEmailAdd() {
        this.EmailAdds.push({
            Index: this.EmailAdds().length,
            beApost: ko.observable(''),
        });
    }
    removeEmailAdd = (data) => {
        if (data.Index < 1)
            return;
        this.EmailAdds.remove((item) => item.Index === data.Index);
    };
    newEditUser() {
        let obj = {
            Anrede: ko.observable(null),
            Vorname: ko.observable(null),
            Nachname: ko.observable(null),
            Mobile: ko.observable('+49'),
            EMail: ko.observable(null),
            Rolle: ko.observable(""),
            Benutzer: ko.observable(null),
            Passwort: ko.observable(""),
            PasswortRetry: ko.observable(""),
            Recherche_EMail: ko.observable(""),
            Recherche_Passwort: ko.observable(""),
            Recherche_PasswortRetry: ko.observable(""),
            isAdmin: ko.observable(false),
            LocationOptions: ko.observableArray<{ Id: number; Name: string }>([]),
            SelectedLocationId: ko.observable(""),
            SafeId: ko.observable("")
        };

        return ko.observable(obj);
    };
    editUser = this.newEditUser();
    proto = ko.observableArray(["POP3", "IMAP"]);
    protoval = ko.observableArray([0, 1]);
    protocols = ["POP3", "IMAP"];
    isBeaProtocol = ko.observable(false);
    newBasicInbox() {
        let obj = {
            "EMailAccount_ID": ko.observable(""),
            "EMail_Address": ko.observable(""),
            "IN_ProtokollType": ko.observable(1),
            "IN_UserLogin": ko.observable(""),
            "IN_UserPassword": ko.observable(""),
            "IN_Host": ko.observable(""),
            "IN_Port": ko.observable("993"),
            "IN_ImapFolder": ko.observable("Inbox"),
            "IN_Authentification": ko.observable(1),
            "OUT_ProtokollType": ko.observable(0),
            "OUT_UserLogin": ko.observable(""),
            "OUT_UserPassword": ko.observable(""),
            "OUT_Host": ko.observable(""),
            "OUT_Port": ko.observable(465),
            "OUT_Authentification": ko.observable(0),
            "checkCertificate": ko.observable(true),
            "DeleteAfterDownload": ko.observable(false),
            "UnseenOnly": ko.observable(false),
            "GrabMails": ko.observable(true),
            "IsAutoInsertAddress": ko.observable(true)
        };
        return ko.observable(obj);
    };
    clearInbox() {
        this.inbox().EMailAccount_ID("");
        this.inbox().EMail_Address("");
        this.inbox().IN_ProtokollType(1);
        this.inbox().IN_UserLogin("");
        this.inbox().IN_UserPassword("");
        this.inbox().IN_Host("");
        this.inbox().IN_Port("993");
        this.inbox().IN_ImapFolder("Inbox");
        this.inbox().IN_Authentification(1);
        this.inbox().OUT_ProtokollType(0);
        this.inbox().OUT_UserLogin("");
        this.inbox().OUT_UserPassword("");
        this.inbox().OUT_Host("");
        this.inbox().OUT_Port(465);
        this.inbox().OUT_Authentification(0);
        this.inbox().checkCertificate(true);
        this.inbox().DeleteAfterDownload(false);
        this.inbox().UnseenOnly(false);
        this.inbox().GrabMails(true);
        this.inbox().IsAutoInsertAddress(true);
    }
    clearProvider() {
        this.provider().name('');
        this.provider().in([]);
        this.provider().out('');
        this.provider().imapPort('');
        this.provider().pop3Port('');
        this.provider().smtp([]);
        this.provider().encryption([]);
    }
    IsEditMode = ko.observable(false);
    isMakroEditMode = ko.observable(false);
    inbox = this.newBasicInbox();
    currentView: ko.Observable<String>;
    public showUsers() {
        this.statusVisible(false);
        if (ko.toJS(this.bl())) {
            MainViewModel.RoutingTable.showSettingsView({ view: "users" }, true);
            this.currentView('users');
        }
    }
    public frist() {
        MainViewModel.RoutingTable.showSettingsView({ view: "fristgruende" }, true);
        this.currentView('fristgruende');
    }
    public fristverlaengerungsgrund() {
        MainViewModel.RoutingTable.showSettingsView({ view: "fristverlaengerungsgruende" }, true);
        this.currentView('fristverlaengerungsgruende');
    }
    public showZPEMail() {
        MainViewModel.RoutingTable.showSettingsView({ view: "zpemail" }, true);
        this.currentView('zpemail');
        this.filterType('mail');
    }
    public showAbrechnung() {
        MainViewModel.RoutingTable.showSettingsView({ view: "abrechnung" }, true);
        this.currentView('abrechnung');
    }
    public showStandorte() {
        MainViewModel.RoutingTable.showSettingsView({ view: "standorte" }, true);
        this.currentView('standorte');
    }
    public showKonto() {
        MainViewModel.RoutingTable.showSettingsView({ view: "konto" }, true);
        this.currentView('konto');
    }
    public showRachts() {
        MainViewModel.RoutingTable.showSettingsView({ view: "rechtsform" }, true);
        this.currentView('rechtsform');
    }
    public showMakros() {
        MainViewModel.RoutingTable.showSettingsView({ view: "assistance" }, true);
        this.currentView('assistance');
    }
    public showRefrate() {
        MainViewModel.RoutingTable.showSettingsView({ view: "refrate" }, true);
        this.currentView('refrate');
    }
    public showProfile(e) {
        this.statusVisible(false);
        MainViewModel.RoutingTable.showSettingsView({ view: "profile" }, true);
        this.currentView('profile');
    }
    public showPost() {
        MainViewModel.RoutingTable.showSettingsView({ view: "beA" }, true);
        this.currentView('beA');
        this.filterType('bea');
    }
    public showFKA() {
        MainViewModel.RoutingTable.showSettingsView({ view: "fristen-kalender-adresse" }, true);
        this.currentView('fristen-kalender-adresse');
        this.filterType('fristen-kalender-adresse');
    }
    public showInboxes() {
        MainViewModel.RoutingTable.showSettingsView({ view: "mail-postfach" }, true);
        this.currentView('mail-postfach');
        this.filterType('mail-postfach');
    }
    public showInstances() {
        MainViewModel.RoutingTable.showSettingsView({ view: "instances" }, true);
        this.currentView('instances');
        this.filterType('instances');
    }
    public showCourts() {
        MainViewModel.RoutingTable.showSettingsView({ view: "courts" }, true);
        this.currentView('courts');
        this.filterType('courts');
    }
    public showAppointmentTypes(){
        MainViewModel.RoutingTable.showSettingsView({ view: "terminarten" }, true);
        this.currentView('terminarten');
    }
    cancel() {
        this.error("");
    }
    async deleteData() {
        $("#deleteConfirm").modal('hide');
        try {
            if (ko.toJS(this.temp) == "referat") {
                await RNSAPI.deleteReferat(this.deleteDataValue.toString());
                this.updateReferat();
            }
            else if (ko.toJS(this.temp) == "makro") {
                await RNSAPI.deleteMakro(this.deleteDataValue.toString()).then((data) => {
                    this.getMakros();
                }).catch((error) => {
                    console.log(error);
                });
            }
            else if (ko.toJS(this.temp) == "deleteUser") {
                let res = await RNSAPI.deleteLawFirmUser(this.deleteDataValue.toString());
                if (res.Type == "DeleteUserUnSuccessfullStillJoined") {
                    this.assignedUserCases(ko.toJS(res.Payload.assignedCases));
                    $("#userAssigned").modal("show");
                }
                this.updateUsers();
            }
            else {
                await RNSAPI.deleteRechtsformen(this.deleteDataValue.toString());
                this.updateLegalForms();
            }
        }
        catch (error) {
            alert("Beim Löschen ist ein Fehler aufgetreten!");
        }
    }
    async navigateToCase(data) {
        window.open(`/#/new/${encodeURIComponent(data)}`);
    }
    newFrist() {
        this.deadlineReason().DeadlineNumber("");
        this.deadlineReason().DeadlineDescription("");
        this.deadlineReason().DurationAmount("2");
        this.deadlineReason().DurationIntervall("1");
        this.deadlineReason().PreDeadlines([]);
        this.deadlineReason().PreDeadlines.push(this.newPreDeadlinePackage(null, true));
        this.fristModalTitle("FRISTGRUND ANLEGEN");
        this.fristStatus(true);
        this.createDeadlineReason(true);
        $("#fristModal").modal('show');
    }
    newFristExtenstionReason() {
        this.DeadlineExtensionReason('');
        $("#extendFristReasonModal").modal('show');
    }
    newDeadlineMakro() {
        this.showNotificationTitle(false);
        this.newMakro(this.newDeadlinePackage());
        this.showStack(false);
        this.isMakroEditMode(false);
        $("#deadlineMakro").modal('show');
    }
    showStack = ko.observable(false);
    showNotificationTitle = ko.observable(false);
    newMakro = ko.observable(null);
    newEntry = ko.observable(null);
    newDeadlinePackage() {
        let obj = {
            id: 0,
            Titel: ko.observable(""),
            Kommentar: ko.observable(""),
            Notiz: ko.observable(""),
            entrys: ko.observableArray([])
        };
        obj.entrys.push(this.newEntryPackage());
        return obj;
    }
    newEntryPackage() {
        let obj = {
            isDeadline: ko.observable(null),
            typeId: ko.observable(null),
            typeName: ko.observable(null),
            saved: ko.observable(false),
            display: ko.observable(null),
            removed: ko.observable(null),
            amount: ko.observable(7),
            intervall: ko.observable("0"),
            mode: ko.observable("1"),
        };
        return obj;
    }
    mapMakro(makro) {
        let obj = {
            id: makro.ID,
            Titel: ko.observable(makro.Name),
            Kommentar: ko.observable(makro.Comment),
            Notiz: ko.observable(makro.NoteSuggestion),
            entrys: ko.observableArray([])
        };
        for (let item of makro.Items)
            obj.entrys.push(this.mapMakroEntry(item));
        return obj;
    }
    mapMakroEntry(item) {
        let obj = {
            isDeadline: ko.observable(item.IsDeadline),
            typeId: ko.observable(item.TypeId),
            typeName: ko.observable(item.TypeName),
            saved: ko.observable(false),
            display: ko.observable(null),
            removed: ko.observable(null),
            amount: ko.observable(item.Amount),
            intervall: ko.observable(item.Intervall),
            mode: ko.observable(item.Mode),
        };
        return obj;
    }
    addNewEntryMakro() {
        this.newMakro().entrys.push(this.newEntryPackage());
    }
    async safeMakro() {
        let deadlinePackage = ko.toJS(this.newMakro());
        let obj = {
            id: deadlinePackage.id,
            name: deadlinePackage.Titel,
            comment: deadlinePackage.Kommentar,
            noteSuggestion: deadlinePackage.Notiz,
            inactive: null,
            items: ko.toJS(this.newMakro().entrys())
        };
        if (obj.id === 0) {
            await (RNSAPI.addMakro(obj).then((res) => {
                $("#deadlineMakro").modal("hide");
                this.getMakros();
            })).catch((error) => {
                console.log(error);
            });
        }
        else {
            await (RNSAPI.editMakro(obj).then((res) => {
                $("#deadlineMakro").modal("hide");
                this.getMakros();
            })).catch((error) => {
                console.log(error);
            });
        }
    }
    activadePlus() {
        let show = false;
        let openEntrys = this.newMakro().entrys().filter(e => ko.toJS(e.typeId) === null);
        if (openEntrys.length === 0) {
            show = true;
        }
        return show;
    }
    removeMakro(index: number) {
        if (ko.toJS(this.newMakro().entrys()[ko.toJS(index)].removed) === null) {
            this.newMakro().entrys()[ko.toJS(index)].removed(false);
        }
        else {
            this.newMakro().entrys.splice(ko.toJS(index), 1);
        }
    }
    selectAppointmentOrDeadline = (index: number, isDeadline: boolean) => {
        this.newMakro().entrys()[ko.toJS(index)].isDeadline(isDeadline);
    };
    selectDeadline = (index: number) => {
        this.newMakro().entrys()[ko.toJS(index)].isDeadline(true);
    };
    setType = (index: number, typ: string) => {
        this.newMakro().entrys()[ko.toJS(index)].typeId(typ);
        if (typ === 'G')
            this.newMakro().entrys()[ko.toJS(index)].typeName('Mündliche Verhandlung');
        else if (typ === 'V')
            this.newMakro().entrys()[ko.toJS(index)].typeName('Verkündungstermin');
    };
    collapseLogic(index: number) {
        if (ko.toJS(this.newMakro().entrys()[ko.toJS(index)].display) === null) {
            if (ko.toJS(index) === 0)
                this.newMakro().entrys()[ko.toJS(index)].display(true);
            else
                this.newMakro().entrys()[ko.toJS(index)].display(false);
        }
        else {
            for (let i = 0; i < ko.toJS(this.newMakro().entrys()).length; i++) {
                let display = false;
                if (i === ko.toJS(index) && ko.toJS(this.newMakro().entrys()[ko.toJS(index)].display) === false)
                    display = true;
                this.newMakro().entrys()[i].display(ko.toJS(display));
            }
        }
    }
    async beginStack() {
        this.showNotificationTitle(false);
        if (ko.toJS(this.newMakro().Titel) !== "")
            this.showStack(true);
        else
            this.showNotificationTitle(true);
    }
    newLegalform() {
        this.rachtsform().Anrede("");
        this.rachtsform().Briefanrede("");
        this.rachtsform().NameID("");
        this.rachtsform().AnredeForm("");
        this.rachtsform().RechtsformType("");
        this.rachtsModalTitle("NEUE RECHTSFORM");
        $("#newRachtsform").modal('show');
    }
    newreferat() {
        this.referat().referatName("");
        this.referat().referatId("");
        this.referatModalTitle("NEUR STANDORT");
        (<HTMLInputElement>document.getElementById("referatId")).disabled = false;
        $("#newRefrate").modal('show');
    }
    confirmDeletion() {
        $("#deleteConfirm").modal('show');
    }
    remove(index: number) {
        if (ko.toJS(this.deadlineReason().PreDeadlines()[ko.toJS(index)].removed) === null) {
            this.deadlineReason().PreDeadlines()[ko.toJS(index)].removed(false);
        }
        else {
            this.deadlineReason().PreDeadlines.splice(ko.toJS(index), 1);
        }
    }
    async getDeadlineReasons() {
        let fristReasons = await RNSAPI.getDeadlineReasons();
        this.deadlineReasons(fristReasons.Payload.Reasons.map((r) => {
            r.actionHandlers = [{
                    icon: "folder-download",
                    name: 'Fristgrund ausw\u00e4hlen',
                    action: async () => {
                        if (this.newMakro().entrys().filter(e => e.typeId() === null).length === 0) return;
                        this.newMakro().entrys().filter(e => e.typeId() === null)[0].removed(null);
                        this.newMakro().entrys().filter(e => e.typeId() === null)[0].typeName(r["DeadlineDescription"]);
                        let setValue = true;
                        if (typeof r["DurationAmount"] !== 'undefined' && r["DurationAmount"] !== null && r["DurationAmount"] !== "")
                            this.newMakro().entrys().filter(e => e.typeId() === null)[0].amount(Number(r["DurationAmount"]));
                        else
                            setValue = false;
                        if (typeof r["DurationIntervall"] !== 'undefined' && r["DurationIntervall"] !== null && r["DurationIntervall"] !== "")
                            this.newMakro().entrys().filter(e => e.typeId() === null)[0].intervall(r["DurationIntervall"].toString());
                        else
                            setValue = false;
                        if(setValue)
                            this.newMakro().entrys().filter(e => e.typeId() === null)[0].mode("2");
                        this.newMakro().entrys().filter(e => e.typeId() === null)[0].typeId(r["DeadlineNumber"]);
                    },
                    isSelectionEvent: true
                }];
            return r;
        }));
    }
    newPreDeadlinePackage(item, isFirst) {
        return {
            ID: ko.observable(item ? item.ID : 0),
            isFirst: ko.observable(item ? item.IsFirst : (isFirst ? true : false)),
            removed: ko.observable(null),
            Duration: ko.observable(item ? item.Duration.toString() : '7'),
            DurationIntervall: ko.observable(item ? item.DurationIntervall : '0'),
            calculationAmount: ko.observable("7 Tage")
        };
    }
    addNewEntry() {
        this.deadlineReason().PreDeadlines.push(this.newPreDeadlinePackage(null, false));
    }
    async updateFrist() {
        let fristReasons = await RNSAPI.getDeadlineReasons();
        this.fristReasons(fristReasons.Payload.Reasons.map((c) => {
            c.actionHandlers = [];
            if (c.IsEmergencyDeadline)
                c.actionHandlers.push({ icon: "exclamation-circle", name: "Notfrist!", action: async () => { } });
            if (c.DeadlineVerifcation === true)
                c.actionHandlers.push({ icon: "check-double", name: "Verifizierungs-Grund", action: async () => { } });
            if (c.DeadlineVerificationCompletion === true)
                c.actionHandlers.push({ icon: "check-circle", name: "Verifizierungserledigung", action: async () => { }, });
            c.actionHandlers.push({
                icon: "pencil-alt",
                name: "Bearbeiten",
                action: async () => {
                    this.deadlineReason().DeadlineDescription(c.DeadlineDescription);
                    this.deadlineReason().DurationAmount(c.DurationAmount !== 0 ? c.DurationAmount : "");
                    this.deadlineReason().DurationIntervall(c.DurationIntervall !== null ? c.DurationIntervall.toString() : "");
                    this.deadlineReason().DeadlineNumber(c.DeadlineNumber);
                    this.deadlineReason().PreDeadlines(c.Predeadlines.map((item) => {
                        return this.newPreDeadlinePackage(item, false);
                    }));
                    this.fristModalTitle("FRISTGRUND \"" + c.DeadlineNumber + "\" ÄNDERN");
                    this.fristStatus(false);
                    this.createDeadlineReason(false);
                    (<HTMLInputElement>(document.getElementById("isEmergencyDeadline"))).checked = c.IsEmergencyDeadline;
                    (<HTMLInputElement>(document.getElementById("calculateOnPreviousDay"))).checked = c.CalculateLikePreDeadline;
                    if (this.hasVerificationRights()) {
                        (<HTMLInputElement>(document.getElementById("verificationReason"))).checked = c.DeadlineVerifcation;
                        (<HTMLInputElement>(document.getElementById("verificationCompletionReason"))).checked = c.DeadlineVerificationCompletion;
                    }
                    $("#fristModal").modal('show');
                }
            });
            return c;
        }));
    }
    showNewAppointmentType(){
        this.appointmentType().Id(0);
        this.appointmentType().Name("");
        this.appointmentType().TypeId("");
        this.appointmentType().SubjectSuggestion("");
        this.appointmentType().OutlookShowAsBusy(true);
        (<HTMLInputElement>document.getElementById("OutlookShowAsBusy")).checked = true;
        (<HTMLInputElement>document.getElementById("appointmentAllDay")).checked = false;
        if(ko.toJS(this.hasVerificationRights))
            (<HTMLInputElement>document.getElementById("appointmentVerification")).checked = true;

        this.appointmentModalTitle("Terminart anlegen");
        this.createAppointmentType(true);
        $("#appointmentTypeModal").modal('show');
    }
    async updateReferat() {
        let units = await RNSAPI.getReferate();
        this.units(units.Payload.Units.sort((a, b) => a.Name.trim().toLowerCase().localeCompare(b.Name.trim().toLowerCase())).map((c) => {
            c.actionHandlers = [
                {
                    icon: "pencil-alt",
                    name: "Bearbeiten",
                    action: async () => {
                        this.referat().referatName(c.Name);
                        this.referat().referatId(c.Id);
                        this.referateStatus(false);
                        this.referatModalTitle("REFERAT \"" + c.Id + "\" ÄNDERN");
                        (<HTMLInputElement>document.getElementById("referatId")).disabled = true;
                        $("#newRefrate").modal('show');
                    }
                },
                {
                    icon: "trash-alt", name: "Löschen", action: async () => {
                        $("#confirm").modal('show');
                        this.temp("referat");
                        this.deleteDataValue = ko.toJS(c.Id);
                        this.deleteModalTitle("REFERAT LÖSCHEN");
                        this.deleteModalText("Möchten Sie das Referat " + c.Id + " \"" + c.Name + "\" wirklich löschen?");
                        this.confirmDeletion();
                    }
                }
            ];
            return c;
        }));
    }
    async updateLegalForms() {
        let legalforms = await RNSAPI.getRechtsformen();
        this.legalforms(legalforms.Payload.LegalForms.map((c) => {
            c.actionHandlers = [
                {
                    icon: "pencil-alt",
                    name: "Bearbeiten",
                    action: async () => {
                        this.rachtsform().NameID(c.NameID);
                        this.rachtsform().Briefanrede(c.Briefanrede);
                        this.rachtsform().Anrede(c.Anrede);
                        this.rachtsform().RechtsformType(c.RechtsformType);
                        this.rachtsform().AnredeForm(c.AnredeForm);
                        this.rachtsStatus(false);
                        this.rachtsModalTitle("RECHTSFORM \"" + c.NameID + "\" ANLEGEN");
                        $("#newRachtsform").modal('show');
                    }
                },
                {
                    icon: "trash-alt", name: "Löschen", action: async () => {
                        this.deleteDataValue = ko.toJS(c.NameID);
                        this.deleteModalTitle("RECHTSFORM \"" + c.NameID + "\" LÖSCHEN");
                        this.confirmDeletion();
                    }
                }
            ];
            return c;
        }));
    }
    async saveReferat() {
        this.error("");
        if (this.referat().referatName() !== "" && this.referat().referatId() !== "") {
            if (this.referat().referatId().length < 2) {
                this.error("Beim Kürzel können nur 2 Ziffern eingegeben werden.");
                return;
            }
            if (this.referat().referatName().length > 30) {
                this.error(" Der Referatsname darf nicht länger als 30 Zeichen sein.");
                return;
            }
            try {
                if (this.referateStatus() == true) {
                    let result = await RNSAPI.addReferat(this.referat().referatId(), this.referat().referatName());
                    this.updateReferat();
                    if (result !== null) {
                        $('#newRefrate').modal('hide');
                    }
                }
                else {
                    let result = await RNSAPI.updateReferat(this.referat().referatId(), this.referat().referatName());
                    this.updateReferat();
                    if (result !== null) {
                        $('#newRefrate').modal('hide');
                    }
                }
            }
            catch (e) {
                this.referatResult("<i class='fas fa-exclamation-circle '></i> Das Referat konnte nicht hinzugef&uuml;gt werden.");
            }
        }
        else {
            this.error("Bitte füllen Sie die Pflichtfelder aus!");
            this.referatResult("<i class='fas fa-exclamation-circle '></i> Es wurden nicht alle Felder ausgef&uuml;llt.");
        }
    }
    async saveFristExtensionReason() {
        let res = (await RNSAPI.insFristDeadlineReasons(ko.toJS(this.DeadlineExtensionReason)));
        if (res.Type === "InsertFristExtensionReasonsSuccessful") {
            this.getFristDeadlineReasons();
            $("#extendFristReasonModal").modal("hide");
        }
        else {
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Hinzufügen');
            this.statusModalText('Der Verlängerungsgrund konnte nicht gespeichert werden.');
            $("#statusModal").modal('show');
        }
    }
    async saveFrist() {
        if (ko.toJS(this.deadlineReason().DeadlineNumber) == "" || ko.toJS(this.deadlineReason().DeadlineDescription) == "") {
            this.error("Bitte füllen Sie die Pflichtfelder aus!");
        }
        else {
            const toDays = (amountStr: any, intervallStr: any) => {
                const amount = parseInt(ko.toJS(amountStr) || '0', 10);
                const intervall = parseInt(ko.toJS(intervallStr) || '0', 10);
                if (isNaN(amount))
                    return 0;
                switch (intervall) {
                    case 0:
                        return amount;
                    case 1:
                        return amount * 7;
                    case 2:
                        return amount * 30;
                    case 3:
                        return amount * 365;
                    default:
                        return amount;
                }
            };
            const mainDays = toDays(this.deadlineReason().DurationAmount, this.deadlineReason().DurationIntervall);
            let invalidPre = false;
            try {
                const pre = ko.toJS(this.deadlineReason().PreDeadlines) || [];
                for (let i = 0; i < pre.length; i++) {
                    const p = pre[i];
                    const preDays = toDays(p.Duration, p.DurationIntervall);
                    if (preDays > mainDays) {
                        invalidPre = true;
                        break;
                    }
                }
            }
            catch { }
            if (invalidPre) {
                this.error("Die Vorfristen-Berechnung darf nicht länger als die Fristdauer sein.");
                return;
            }
            this.deadlineReason().IsEmergencyDeadline((<HTMLInputElement>document.getElementById("isEmergencyDeadline")).checked);
            this.deadlineReason().CalculateLikePreDeadline((<HTMLInputElement>document.getElementById("calculateOnPreviousDay")).checked);
            let verify = false;
            if (this.hasVerificationRights())
                verify = (<HTMLInputElement>document.getElementById("verificationReason")).checked;
            let verifyCompletion = false;
            if (this.hasVerificationRights())
                verifyCompletion = (<HTMLInputElement>(document.getElementById("verificationCompletionReason"))).checked;
            this.deadlineReason().DeadlineVerifcation(verify);
            this.deadlineReason().DeadlineVerificationCompletion(verifyCompletion);
            this.deadlineReason().DeadlineVerifcation(verify);
            try {
                if (this.fristStatus() == true) {
                    let result = await RNSAPI.addFrist(ko.toJS(this.deadlineReason()));
                    this.updateFrist();
                    if (result !== null) {
                        $('#fristModal').modal('hide');
                    }
                }
                else {
                    let result = await RNSAPI.updateFrist(ko.toJS(this.deadlineReason()));
                    this.updateFrist();
                    if (result !== null) {
                        $('#fristModal').modal('hide');
                    }
                }
            }
            catch (e) {
                this.referatResult("<i class='fas fa-exclamation-circle '></i> Das Referat konnte nicht hinzugef&uuml;gt werden.");
            }
        }
    }
    async saveRachts() {
        if (ko.toJS(this.rachtsform().NameID) == "") {
            this.error("Bitte füllen Sie die Pflichtfelder aus!");
        }
        else {
            try {
                if (this.rachtsStatus() == true) {
                    let result = await RNSAPI.addRechtsformen(ko.toJS(this.rachtsform()));
                    if (result !== null) {
                        this.updateLegalForms();
                        $('#newRachtsform').modal('hide');
                    }
                    else {
                        this.referatResult("<i class='fas fa-exclamation-circle '></i> Das Referat konnte nicht hinzugef&uuml;gt werden.");
                    }
                }
                else {
                    let result = await RNSAPI.updateRechtsformen(ko.toJS(this.rachtsform()));
                    if (result !== null) {
                        this.updateLegalForms();
                        $('#newRachtsform').modal('hide');
                    }
                }
            }
            catch (e) {
                this.referatResult("<i class='fas fa-exclamation-circle '></i> Das Referat konnte nicht hinzugef&uuml;gt werden.");
            }
        }
    }
    async updateMail() {
        this.inbox().EMail_Address("");
        this.inbox().IN_ProtokollType(0);
        this.inbox().IN_UserLogin("");
        this.inbox().IN_UserPassword("");
        this.inbox().IN_Host("");
        this.inbox().IN_Port("993");
        this.inbox().OUT_UserLogin("");
        this.inbox().OUT_UserPassword("");
        this.inbox().OUT_Host("");
        this.inbox().OUT_Port(465);
        this.IsEditMode(false);
        $("#createMail").modal('show');
    }
    changedRoll() {
        if (ko.toJS(this.createUser().Rolle) === "Administrator") {
            (<HTMLInputElement>document.getElementById("addAdminRights")).checked = true;
            (<HTMLInputElement>document.getElementById("addAdminRights")).disabled = true;
        }
        else {
            (<HTMLInputElement>document.getElementById("addAdminRights")).checked = false;
            (<HTMLInputElement>document.getElementById("addAdminRights")).disabled = false;
        }
        if (ko.toJS(this.editUser().Rolle) === "Administrator") {
            (<HTMLInputElement>document.getElementById("editAdminRights")).checked = true;
            (<HTMLInputElement>document.getElementById("editAdminRights")).disabled = true;
        }
        else {
            (<HTMLInputElement>document.getElementById("editAdminRights")).checked = false;
            (<HTMLInputElement>document.getElementById("editAdminRights")).disabled = false;
        }
    }
    async updateData() {
        this.editUser().Benutzer(this.currentUserSymbol());
        var height = $(window).scrollTop();
        if (!Utils.checkErrors(["Anrede", "Vorname", "Nachname", "EMail", "Benutzer", "Rolle"], this.editUser(), "Edit", [Utils.checkString])) {
            this.statusText('Es wurden nicht alle erforderlichen Daten eingegeben.');
            this.statusVisible(true);
            return;
        }
        if (!Utils.checkErrors(["EMail"], this.editUser(), "Edit", [Utils.checkEmail])) {
            this.statusText('Ung&uuml;ltiges E-Mail Adressen Format.');
            this.statusVisible(true);
            return;
        }
        // Validate new password only if user provided one; otherwise skip password checks
        const newPw = ko.toJS(this.editUser().Passwort());
        const newPwRetry = ko.toJS(this.editUser().PasswortRetry());
        const hasPwInput = ((newPw ?? '').trim() !== '') || ((newPwRetry ?? '').trim() !== '');
        if (hasPwInput) {
            if (newPw !== newPwRetry) {
                Utils.checkErrors(["Passwort", "PasswortRetry"], this.editUser(), "Edit", [Utils.checkString]);
                this.statusText('Die neu eingegebenen Passw&ouml;rter stimmen nicht &uuml;berein.');
                this.statusVisible(true);
                return;
            }
            if (!/^(?=.{12,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/.test(String(newPw))) {
                this.statusText('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
                this.statusVisible(true);
                return;
            }
        }
        const editUser = ko.toJS(this.editUser());
        if (this.editUser().Rolle() === "Anwalt") {
            editUser.Rolle = '0';
        }
        else if (this.editUser().Rolle() === "Administrator")
            editUser.Rolle = '2';
        else if (this.editUser().Rolle() === "PA / Sekretariat")
            editUser.Rolle = '3';
        else if (this.editUser().Rolle() === "Viewer")
            editUser.Rolle = '4';
        else {
            editUser.Rolle = '1';
        }
        editUser.isAdmin = (<HTMLInputElement>document.getElementById("editAdminRights")).checked;
        let result = await RNSAPI.updateLawFirmUser(editUser);
        if (result.Type === "UpdateUserSuccessful") {
            $("#editUser").modal('hide');
            this.updateUsers();
            this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
            this.statusModalText('Der Benutzer <span class="text-default">' + this.editUser().Benutzer() + '</span> wurde erfolgreich bearbeitet.');
            $("#statusModal").modal('show');
        }
        else {
            this.statusText('Es ist ein Fehler aufgetreten.<br />Versuchen Sie es sp&auml;ter erneut oder kontaktieren Sie unseren Support unter info@rainmaker.de');
            this.statusVisible(true);
        }
    }
    async updateAccountData() {
        this.editUser().Benutzer(this.currentUserSymbol());
        var height = $(window).scrollTop();
        if (!Utils.checkErrors(["Anrede", "Vorname", "Nachname", "EMail", "Benutzer", "Rolle"], this.editUser, "Edit", [Utils.checkString])) {
            this.statusText('Es wurden nicht alle erforderlichen Daten eingegeben.');
            this.statusVisible(true);
            return;
        }
        if (!Utils.checkErrors(["EMail"], this.editUser, "Edit", [Utils.checkEmail])) {
            this.statusText('Ung&uuml;ltiges E-Mail Adressen Format.');
            this.statusVisible(true);
            return;
        }
        // Validate new password only if user provided one; otherwise skip password checks
        const newPw = ko.toJS(this.editUser().Passwort());
        const newPwRetry = ko.toJS(this.editUser().PasswortRetry());
        const hasPwInput = ((newPw ?? '').trim() !== '') || ((newPwRetry ?? '').trim() !== '');
        if (hasPwInput) {
            if (newPw !== newPwRetry) {
                Utils.checkErrors(["Passwort", "PasswortRetry"], this.editUser, "Edit", [Utils.checkString]);
                this.statusText('Die neu eingegebenen Passw&ouml;rter stimmen nicht &uuml;berein.');
                this.statusVisible(true);
                return;
            }
            if (!/^(?=.{12,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/.test(String(newPw))) {
                this.statusText('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
                this.statusVisible(true);
                return;
            }
        }
        const editUser = ko.toJS(this.editUser());
        if (this.editUser().Rolle() === "Anwalt") {
            editUser.Rolle = '0';
        }
        else if (this.editUser().Rolle() === "Administrator")
            editUser.Rolle = '2';
        else if (this.editUser().Rolle() === "PA / Sekretariat")
            editUser.Rolle = '3';
        else if (this.editUser().Rolle() === "Viewer")
            editUser.Rolle = '4';
        else {
            editUser.Rolle = '1';
        }
        editUser.isAdmin = (<HTMLInputElement>document.getElementById("editAdminRights")).checked;
        let result = await RNSAPI.updateLawFirmUser(editUser);
        if (result.Type === "UpdateUserSuccessful") {
            $("#editUser").modal('hide');
            this.updateUsers();
            this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
            this.statusModalText('Der Benutzer <span class="text-default">' + this.editUser().Benutzer() + '</span> wurde erfolgreich bearbeitet.');
            $("#statusModal").modal('show');
        }
        else {
            this.statusText('Es ist ein Fehler aufgetreten.<br />Versuchen Sie es sp&auml;ter erneut oder kontaktieren Sie unseren Support unter info@rainmaker.de');
            this.statusVisible(true);
        }
    }
    loadNewUserModal = async () => {
        await this.loadLocationOptions();
        $("#addNewUser").modal("show");
    };
    async loadLocationOptions() {
        const locationValues = await RNSAPI.getReferate();
        const units = locationValues.Payload.Units ?? [];
        units.unshift({ Id: null, Name: 'Alle Standorte' });
        this.createUser().LocationOptions(units);
    }
    async updateUsers() {
        let users = await RNSAPI.getLawFirmUsers();
        this.users(users.Payload.Users.map((c) => {
            c.actionHandlers = [];
            if (!c.IsDeleted) {
                c.actionHandlers.push({
                    icon: "pencil-alt", name: "Bearbeiten", action: async () => {
                        let data = await RNSAPI.getLawFirmUser(c.Shorthandsymbol);
                        let locationValues = await RNSAPI.getReferate();
                        if (data.Type === "GetUserSuccessful") {
                            this.editUser().Anrede(data.Payload.User.Anrede);
                            this.editUser().Vorname(data.Payload.User.Vorname);
                            this.editUser().Nachname(data.Payload.User.Nachname);
                            this.editUser().Mobile(data.Payload.User.Telefon);
                            this.editUser().EMail(data.Payload.User.EMail);
                            this.editUser().Benutzer(data.Payload.User.Benutzer);
                            this.editUser().SafeId(data.Payload.User.SafeId);
                            this.editUser().LocationOptions(locationValues.Payload.Units);
                            this.editUser().LocationOptions.unshift({ Id: null, Name: 'Alle Standorte' });
                            this.editUser().SelectedLocationId(data.Payload.User.LocationId);
                            this.currentUserSymbol(data.Payload.User.Benutzer);
                            if (data.Payload.User.IsAdmin) {
                                (<HTMLInputElement>document.getElementById("editAdminRights")).checked = true;
                            }
                            else {
                                (<HTMLInputElement>document.getElementById("editAdminRights")).checked = false;
                            }
                            if (data.Payload.User.Rolle == '1') {
                                this.editUser().Rolle("ReFa");
                            }
                            else if (data.Payload.User.Rolle == '2') {
                                this.editUser().Rolle("Administrator");
                            }
                            else if (data.Payload.User.Rolle == '3') {
                                this.editUser().Rolle("PA / Sekretariat");
                            }
                            else if (data.Payload.User.Rolle == '4') {
                                this.editUser().Rolle("Viewer");
                            }
                            else {
                                this.editUser().Rolle("Anwalt");
                            }
                            this.editUser().Recherche_EMail(data.Payload.User.Recherche_EMail);
                            this.editUser().Recherche_Passwort(data.Payload.User.Recherche_Passwort);
                            this.editUser().Recherche_PasswortRetry(data.Payload.User.Recherche_PasswortRetry);
                            if (data.Payload.User.Recherche_EMail == null) {
                                this.editUser().Recherche_EMail("");
                            }
                            if (data.Payload.User.Recherche_Passwort == null) {
                                this.editUser().Recherche_Passwort("");
                            }
                            if (data.Payload.User.Recherche_PasswortRetry == null) {
                                this.editUser().Recherche_PasswortRetry("");
                            }
                            $("#editUser").modal('show');
                            this.showUserError('');
                        }
                    }
                });
            }
            if (ko.toJS(c.Shorthandsymbol) !== ko.toJS(RNSAPI.User().username) && !c.IsDeleted) {
                let deleteAction = {
                    icon: "trash-alt", name: "Löschen", action: async () => {
                        this.deleteDataValue = ko.toJS(c.Shorthandsymbol);
                        this.temp("deleteUser");
                        this.deleteModalTitle("Benutzer " + c.Name + " LÖSCHEN ");
                        this.confirmDeletion();
                    }
                };
                c.actionHandlers.push(deleteAction);
                c.actionHandlers.push(ko.toJS(c.IsLocked) ?
                    {
                        icon: "lock", name: "Zugang entperren", action: async () => {
                            this.setLock(false, c.Shorthandsymbol);
                        }
                    } :
                    {
                        icon: "unlock", name: "Zugang sperren", action: async () => {
                            this.setLock(true, c.Shorthandsymbol);
                        }
                    }
                );
            }
            if (c.LocationId == null || c.LocationId == "") {
                c.LocationName = "Alle Standorte";
            }
            return c;
        }));
    }
    async setLock(lock: boolean, userId: string){
        await RNSAPI.setLock(lock, userId).then(res => {
            this.updateUsers();
        }).catch(err => {
            alert("Es ist ein Fehler aufgetreten.");
        });
    }
    async postData() {
        if (!Utils.checkErrors(["Anrede", "Rolle", "Vorname", "Nachname", "Benutzer"], this.createUser(), "New", [Utils.checkString])) {
            this.showUserError('Es wurden nicht alle erforderlichen Daten eingegeben.');
            return;
        }
        if (!Utils.checkErrors(["EMail"], this.createUser(), "New", [Utils.checkEmail])) {
            this.showUserError('Ung&uuml;ltiges E-Mail Adressen Format.');
            return;
        }
        if (this.createUser().Passwort() !== null && this.createUser().PasswortRetry() !== null)
        {
            if (this.createUser().Passwort() !== this.createUser().PasswortRetry()) {
                Utils.checkErrors(["Passwort", "PasswortRetry"], this.createUser(), "New", [Utils.checkString]);
                this.showUserError('Die eingegebenen Passw&ouml;rter f&uuml;r ihre Anmeldung stimmen nicht &uuml;berein.');
                return;
            }
            if (!(ko.toJS(this.createUser().Passwort()) === ko.toJS(this.createUser().PasswortRetry()) && /^(?=.{12,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/.test(ko.toJS(this.createUser().Passwort()).toString()))) {
                this.statusText('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
                this.showUserError('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
                this.hasError(true);
                this.statusVisible(true);
                this.createUser().PasswortRetry("");
                return false;
            }

        }
        this.createUser().isAdmin((<HTMLInputElement>document.getElementById("addAdminRights")).checked);
        let res = await RNSAPI.createLawFirmUser(this.createUser());
        if (res.Type === "CreateUserSuccessful") {
            this.statusModalTitle('<i class="far fa-check-circle mr-2"></i> Erfolgreich');
            this.statusModalText('Der Benutzer <span class="text-default">' + this.createUser().Vorname() + ' ' + this.createUser().Nachname() + '</span> wurde erfolgreich angelegt.');
            $("#addNewUser").modal('hide');
            $("#statusModal").modal('show');
            this.createUser().Anrede("Herr");
            this.createUser().Vorname("");
            this.createUser().Nachname("");
            this.createUser().Telefon("+49");
            this.createUser().EMail("");
            this.createUser().Rolle("Anwalt");
            this.createUser().Benutzer("");
            this.createUser().Passwort("");
            this.createUser().PasswortRetry("");
            this.createUser().Recherche_EMail("");
            this.createUser().Recherche_Passwort("");
            this.createUser().Recherche_PasswortRetry("");
            this.createUser().SafeId("");
            this.createUser().SelectedLocationId("");
            this.update();
        }
        else {
            this.statusModalText('Der Benutzer mit dem K&uuml;rzel <b>' + this.createUser().Benutzer() + '</b> oder der eingegebenen E-Mail-Adresse existiert bereits.<br />Bitte w&auml;hlen Sie ein anderes Benutzerkürzel aus.');
            this.showUserError('Der Benutzer mit dem K&uuml;rzel <b>' + this.createUser().Benutzer() + '</b> oder der eingegebenen E-Mail-Adresse existiert bereits.<br />Bitte w&auml;hlen Sie ein anderes Benutzerkürzel aus.');
        }
    }
    loadInbox = async (id: string) => {
        let result = (await RNSAPI.getInboxById(id));
        let inbox = result.Payload;
        let tempInbox = this.inbox();
        for (let key in tempInbox) {
            if (tempInbox[key] === undefined) {
                tempInbox[key] = inbox[key];
            }
            else {
                tempInbox[key](inbox[key]);
            }
        }
        this.inbox(tempInbox);
    };
    async update() {
        this.updateUsers();
        this.updateReferat();
        this.updateLegalForms();
        this.updateFrist();
        this.getAppointmentTypes();
        this.getAppointmentTypesForMakros();
    }
    async getCurrentUserDetails() {
        const lawFirm = (await RNSAPI.getCurrentLoggedInUser());
        const data = (await RNSAPI.getLawFirmUser(RNSAPI.User().username)).Payload;
        const locations = (await RNSAPI.getReferate()).Payload.Units;
        locations.unshift({ Id: null, Name: 'Alle Standorte' });
        const lawfirmData = data.Data;
        this.locationOptions(locations);
        this.lawfirmDataNew(lawfirmData);
        this.lawFirmData(this.convertBackendObjectToLawFirmData(data.User, lawFirm.LawFirmId));
        if (data.User.RollenName.includes('Admin')) {
            this.lawFirmData().isAdmin = ko.observable<boolean>(true);
            this.bl(true);
            $("#fileName").val(ko.toJS(lawFirm.LawFirmId));
        }
        this.initTooltip();
    }
    initTooltip() {
        $("[data-toggle='tooltip']").tooltip();
    }
    profilePhotoUrl = ko.observable();
    passwort = ko.observable({
        Passwort: ko.observable(''),
        PasswortRetry: ko.observable(''),
        Recherche_Passwort: ko.observable(''),
        Recherche_PasswortRetry: ko.observable('')
    });
    profilePhoto = (data, e) => {
        if (e.target.files[0].size / 1024 / 1024 > 1) {
            window.alert('Dateigröße nicht überschritten 1 MB');
            return;
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onloadend = (onloadend_e) => {
            let result = reader.result;
            this.profilePhotoUrl(result);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    resetPasswortObject = () => {
        return ko.observable({
            Passwort: ko.observable(''),
            PasswortRetry: ko.observable(''),
            Recherche_Passwort: ko.observable(''),
            Recherche_PasswortRetry: ko.observable('')
        });
    };
    passwordsMatch = (create) => {
        var passwort = create ? this.createUser().Passwort() : this.editUser().Passwort();
        var passwortRetry = create ? this.createUser().PasswortRetry() : this.editUser().PasswortRetry();
        if (passwort !== passwortRetry) {
            this.showUserError('Die eingegebenen Passw&ouml;rter f&uuml;r ihre Anmeldung stimmen nicht &uuml;berein.');
        }
        else {
            this.showUserError('');
        }
    };
    clone(obj) {
        var target = new obj.constructor();
        for (var prop in obj) {
            target[prop] = ko.observable(obj[prop]);
        }
        return target;
    }
    async getStandorte() {
        var res = (await RNSAPI.getAssignements()).Payload.Lawfirms;
        if (res.length > 0) {
            this.allStandorte([]);
            this.allStandorte(res.map((standort) => {
                standort.actionHandlers = [{
                        icon: "trash-alt",
                        name: "Löschen",
                        action: async () => {
                            let res = (await RNSAPI.removeLocation(standort.LawfirmID, standort.LawFirmUser));
                            if (res.Type === "RemoveSuccessful") {
                                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                                this.statusModalText('Der Standort wurde erfolgreich entfernt.');
                                $("#statusModal").modal('show');
                                this.getStandorte();
                            }
                            else {
                                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Löschen');
                                this.statusModalText('Der Standort konnte nicht gelöscht werden.');
                                $("#statusModal").modal('show');
                            }
                        }
                    }];
                return standort;
            }));
        }
    }
    async getFKA() {
        let res = (await RNSAPI.getOutlook());
        this.allFKA([]);
        if (res.Type === "GetAccountsSuccessful") {
            this.allFKA(res.Payload.OutlookAccounts.map((fka) => {
                fka.actionHandlers = [{
                        icon: "pencil-alt",
                        name: "Bearbeiten",
                        action: async () => {
                            this.editFKA(true);
                            this.EWSURL(fka.EWSURL);
                            this.UserLogin(fka.UserLogin);
                            this.UserPassword("");
                            this.useOAuth_Creation(fka.UseOAuth2);
                            this.OutlookAccountID(fka.OutlookAccountID);
                            this.OAuthClientId(fka.OAuthClientId);
                            this.OAuthClientSecret(fka.OAuthClientSecret);
                            $("#newFKA").modal("show");
                        }
                    }, {
                        icon: "trash-alt",
                        name: "Löschen",
                        action: async () => {
                            let res = (await RNSAPI.removeOutlook(fka.OutlookAccountID));
                            if (res.Type === "DeleteSuccessful") {
                                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                                this.statusModalText('Das Konto wurde erfolgreich entfernt.');
                                $("#statusModal").modal('show');
                                this.getFKA();
                            }
                            else {
                                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Löschen');
                                this.statusModalText('Das Konto konnte nicht gelöscht werden.');
                                $("#statusModal").modal('show');
                            }
                        }
                    }];
                return fka;
            }));
        }
    }
    async getMailInboxes() {
        let res = (await RNSAPI.getMailInboxes());
        this.allInboxes([]);
        this.allInboxes(res.Payload.MailAccounts.map((fka) => {
            fka.actionHandlers = [{
                    icon: "pencil-alt",
                    name: "Bearbeiten",
                    action: async () => {
                        this.editInbox(true);
                        this.ImapHost(fka.ServerUrl);
                        this.Login(fka.Login);
                        this.BasicPassword("");
                        this.ClientSecret("");
                        this.ClientId(fka.OAuthClientId);
                        this.OAuthTenant(fka.OAuthTenant);
                        this.useOAuth_Inbox(fka.AuthenticationMode === 1 ? true : false);
                        if (fka.Location !== null)
                            this.LocationId(fka.Location.ShorthandSymbol);
                        else
                            this.LocationId("");
                        this.MailAccountID(fka.AccountId);
                        $("#newInbox").modal("show");
                    }
                }];
            fka.LocationName = "Kein Standort";
            if (fka.Location !== null)
                fka.LocationName = fka.Location.Name;
            return fka;
        }));
    }
    async createInstance() {
        await RNSAPI.createInstance(ko.toJS(this.createInstanceName)).then((response) => {
            this.getInstances();
            $("#createInstance").modal("hide");
        }).catch((error) => {
            $("#createInstance").modal("hide");
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Anlegen');
            this.statusModalText('Die Instanz konnte nicht angelegt werden.');
            $("#statusModal").modal('show');
        });
    }
    async createCourt() {
        await RNSAPI.createCourt(ko.toJS(this.Ger_Name), ko.toJS(this.Ger_City), ko.toJS(this.Ger_Name), ko.toJS(this.Ger_Mail), ko.toJS(this.Ger_Phone), ko.toJS(this.Ger_Postcode), ko.toJS(this.Ger_Street), ko.toJS(this.Ger_State), ko.toJS(this.Ger_SafeId)).then((response) => {
            this.getGerichte();
            $("#createCourt").modal("hide");
        }).catch((error) => {
            $("#createCourt").modal("hide");
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Anlegen');
            this.statusModalText('Das Gericht konnte nicht angelegt werden.');
            $("#statusModal").modal('show');
        });
    }
    async updateCourt() {
        await RNSAPI.editCourt(ko.toJS(this.Ger_Name), ko.toJS(this.Ger_City), ko.toJS(this.Ger_Name), ko.toJS(this.Ger_Mail), ko.toJS(this.Ger_Phone), ko.toJS(this.Ger_Postcode), ko.toJS(this.Ger_Street), ko.toJS(this.Ger_State), ko.toJS(this.Ger_SafeId)).then((response) => {
            this.getGerichte();
            $("#createCourt").modal("hide");
        }).catch((error) => {
            $("#createCourt").modal("hide");
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Bearbeiten des Gerichts');
            this.statusModalText('Das Gericht konnte nicht bearbeitet werden.');
            $("#statusModal").modal('show');
        });
    }
    async editInstance() {
        await RNSAPI.updateInstance(ko.toJS(this.editInstanceId), ko.toJS(this.editInstanceName)).then((response) => {
            this.getInstances();
            $("#updateInstance").modal("hide");
        }).catch((error) => {
            $("#updateInstance").modal("hide");
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Bearbeiten');
            this.statusModalText('Die Instanz konnte nicht bearbeitet werden.');
            $("#statusModal").modal('show');
        });
    }
    async getInstances() {
        await RNSAPI.getInstances().then((response) => {
            let res = response as any;
            res = res.map((a) => {
                a.actionHandlers = [{
                        icon: "pencil-alt",
                        name: "Instanz bearbeiten",
                        action: () => {
                            this.editInstanceId(a.Id);
                            this.editInstanceName(a.Name);
                            $("#updateInstance").modal("show");
                        }
                    }];
                return a;
            });
            this.allInstances(res);
        }).catch((error) => { });
    }
    async getGerichte() {
        await RNSAPI.getAdressPagin(8).then((addresses) => {
            let addr = addresses as any;
            this.allGerichtAddresses(addr.map((a) => {
                if (a['Phone'] === '+49')
                    a['Phone'] = '';
                a['CreatedAt'] = moment(a['CreatedAt']).format("DD.MM.YYYY");
                if (a['CreatedAt'] === 'Invalid date')
                    a['CreatedAt'] = "";
                if (a.Name.includes("ýý")) {
                    return "";
                }
                a.actionHandlers = [];
                if (a.IsFavorite === true) {
                    a.actionHandlers.push({
                        icon: "star fas text-warning",
                        name: "Aus Favoriten entfernen",
                        action: () => this.setFavorite(a.Keyword, false)
                    });
                }
                else {
                    a.actionHandlers.push({
                        icon: "star",
                        name: "Zu Favoriten hinzufügen",
                        action: () => this.setFavorite(a.Keyword, true)
                    });
                }
                a.actionHandlers.push({
                    icon: "pencil-alt",
                    name: "Gericht bearbeiten",
                    action: () => {
                        this.Ger_City(a.City);
                        this.Ger_Postcode(a.Postcode);
                        this.Ger_Name(a.Name);
                        this.Ger_Keyword(a.Keyword);
                        this.Ger_Street(a.Street);
                        this.Ger_State(a.State);
                        this.Ger_Mail(a.Mail);
                        this.Ger_Phone(a.Phone);
                        this.Ger_SafeId(a.SafeId);
                        this.editCourt(true);
                        $("#createCourt").modal("show");
                    }
                });
                a.StateName = this.statesTable[a.State];
                return a;
            }));
        }).catch((error) => {
            console.log(error);
            this.allGerichtAddresses([]);
        });
    }
    async getFristDeadlineReasons() {
        let res = (await RNSAPI.getFristDeadlineReasons());
        if (res.Type === "GetFristExtensionReasonsSuccessful") {
            this.allDeadlineExtensionReasons([]);
            let list = res.Payload.DeadlineExtendReasonTypes.map((deadlineExtenstionRea) => {
                deadlineExtenstionRea.actionHandlers = [{
                        icon: "trash-alt",
                        name: "Löschen",
                        action: async () => {
                            let res = (await RNSAPI.delFristDeadlineReasons(deadlineExtenstionRea.ID));
                            if (res.Type === "DeleteFristExtensionReasonsSuccessful") {
                                this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
                                this.statusModalText('Der Verlängerungsgrund wurde erfolgreich entfernt.');
                                $("#statusModal").modal('show');
                                this.getFristDeadlineReasons();
                            }
                            else {
                                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Löschen');
                                this.statusModalText('Der Verlängerungsgrund konnte nicht gelöscht werden.');
                                $("#statusModal").modal('show');
                            }
                        }
                    }];
                return deadlineExtenstionRea;
            });
            list.sort((a, b) => a.Reason.localeCompare(b.Reason));
            this.allDeadlineExtensionReasons(list);
        }
    }
    async getMakros() {
        this.showStack(false);
        this.newMakro(null);
        await RNSAPI.getMakros(true).then((data) => {
            this.allMakros([]);
            let makros = data as any;
            this.allMakros(makros.map((c) => {
                c.actionHandlers = [
                    {
                        icon: "pencil-alt",
                        name: "Bearbeiten",
                        action: async () => {
                            this.showStack(false);
                            this.newMakro(null);
                            await RNSAPI.getMakroForEditionById(c.ID).then((data) => {
                                let makro = data as any;
                                this.showNotificationTitle(false);
                                this.newMakro(this.mapMakro(ko.toJS(makro)));
                                this.isMakroEditMode(true);
                                $("#deadlineMakro").modal('show');
                            }).catch((error) => {
                                console.log(error);
                            });
                        }
                    },
                    {
                        icon: "trash-alt",
                        name: "Löschen",
                        action: async () => {
                            $("#confirm").modal('show');
                            this.temp("makro");
                            this.deleteDataValue = ko.toJS(c.ID);
                            this.deleteModalTitle("Makro LÖSCHEN");
                            this.deleteModalText("Möchten Sie das Makro \"" + c.Name + "\" wirklich löschen?");
                            this.confirmDeletion();
                        }
                    }
                ];
                if (c.Inactive) {
                    c.IsDeleted = true;
                    c.actionHandlers.push({
                        icon: "play",
                        name: "Inaktives Makro reaktivieren?",
                        action: async () => {
                            this.setMakroAcitve(c.ID, true);
                        }
                    });
                }
                else {
                    c.actionHandlers.push({
                        icon: "pause",
                        name: "Makro deaktivieren?",
                        action: async () => {
                            this.setMakroAcitve(c.ID, false);
                        }
                    });
                }
                c.actionHandlers.reverse();
                return c;
            }));
        }).catch((error) => {
            this.allMakros([]);
        });
    }
    async setMakroAcitve(makroId: number, active: boolean) {
        await RNSAPI.setMakroActivity(makroId, active).then((data) => {
            this.getMakros();
        }).catch((error) => {
            console.log(error);
        });
    }
    async saveUserProfile() {
        this.statusVisible(false);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if (!Utils.checkMultipleErrors(["Firstname", "Lastname", "FormOfAddress"], this.lawFirmData(), "", [Utils.checkString])) {
            this.statusText('Bitte Pflichtfelder ausfüllen');
            this.hasError(true);
            this.statusVisible(true);
            return;
        }
        if (!Utils.checkMultipleErrors(["Mail"], this.lawFirmData(), "", [Utils.checkEmail])) {
            this.statusText('Ung&uuml;ltiges E-Mail Adressen Format.');
            this.hasError(true);
            this.statusVisible(true);
            return;
        }
        else {
            if (this.lawFirmData().Password) {
                const isValid = this.checkAndValidatePassword();
                if (isValid) {
                    Postbox.publisher().publish(true, "DoesUserChangedThePassword");
                }
                else {
                    return;
                }
            }
            this.userPassword("");
            this.executeSaveUserProfileLoader(false);
            this.passwordError("");
            $("#VerifyPasswordDialogExt").modal('show');
        }
    }

    async saveLawfirmData(){
        this.statusVisible(false);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if (!Utils.checkMultipleErrors(["LawfirmName", "Strasse", "Postleitzahl", "Ort"], this.lawfirmDataNew(), "", [Utils.checkString])) {
            this.statusText('Bitte Pflichtfelder ausfüllen');
            this.hasError(true);
            this.statusVisible(true);
            return;
        }

        this.executeSaveUserProfileLoader(true);
        await RNSAPI.updateLawfirmData(ko.toJS(this.lawfirmDataNew)).then((data) => {
            this.handleUpdateUserDataResponse('Erfolgreich gespeichert.', false);
        }).catch((error) => {
            this.handleUpdateUserDataResponse('Aktualisierung der Kanzleidaten war nicht erfolgreich.', true);
        });
    }

    private convertLawFirmDataToBackendObject(): any {
        const object = {
            Anrede: this.lawFirmData().FormOfAddress,
            Vorname: this.lawFirmData().Firstname,
            Nachname: this.lawFirmData().Lastname,
            // Adresszusatz: this.lawFirmData().AdditionalAddress,
            // Strasse: this.lawFirmData().Address,
            // Postleitzahl: this.lawFirmData().PostCode,
            // Ort: this.lawFirmData().Place,
            //Telefon: this.lawFirmData().Phone,
            EMail: this.lawFirmData().Mail,
            // Website: this.lawFirmData().Website,
            // Recherche_EMail: this.lawFirmData().SoldanMail,
            Passwort: this.lawFirmData().Password,
            PasswortRetry: this.lawFirmData().PasswordRetry,
            // Rolle: this.lawFirmData().UserRole,
            // RollenName: this.lawFirmData().RoleName,
            Mobile: this.lawFirmData().Mobile,
            //Title: this.lawFirmData().Title,
            // Recherche_Passwort: this.lawFirmData().SoldanPassword,
            // Recherche_PasswortRetry: this.lawFirmData().SoldanPassword,
            Benutzer: this.lawFirmData().Username,
            // IsLocked: this.lawFirmData().IsLocked,
            // Kanzleiname: this.lawFirmData().LawFirmName,
            // isAdmin: this.lawFirmData().isAdmin,
            SafeId: this.lawFirmData().SafeId,
            CurrentPassword: ko.toJS(this.userPassword),
            LocationId: this.lawFirmData().LocationId
        };
        return object;
    }
    private convertBackendObjectToLawFirmData(data: any, lawFirmId: string): any {
        const object = {
            FormOfAddress: data.Anrede,
            Firstname: data.Vorname,
            Lastname: data.Nachname,
            AdditionalAddress: data.Adresszusatz,
            Address: data.Strasse,
            PostCode: data.Postleitzahl,
            Place: data.Ort,
            Phone: data.Telefon,
            Mail: data.EMail,
            Website: data.Website,
            SoldanMail: data.Recherche_EMail,
            Password: data.Passwort,
            PasswordRetry: data.PasswortRetry,
            UserRole: data.Rolle,
            RoleName: data.RollenName,
            Mobile: data.Mobile,
            Title: data.Title,
            SoldanPassword: data.Recherche_Passwort,
            Username: data.Benutzer,
            IsLocked: data.IsLocked,
            LawFirmName: data.LawfirmName,
            LawFirmId: lawFirmId === "" ? "" : lawFirmId,
            SafeId: data.SafeId,
            LocationId: data.LocationId,
        };
        return object;
    }
    private checkAndValidatePassword(): boolean {
        if (!this.lawFirmData().Password || !this.lawFirmData().PasswordRetry) {
            this.statusText('Das wiederholte Passwort für Ihre Anmeldung darf nicht leer sein.');
            this.hasError(true);
            this.statusVisible(true);
            return false;
        }
        if (this.lawFirmData().Password.toString() === "" || this.lawFirmData().PasswordRetry.toString() === "") {
            this.statusText('Das wiederholte Passwort für Ihre Anmeldung darf nicht leer sein.');
            this.hasError(true);
            this.statusVisible(true);
            return false;
        }
        if (this.lawFirmData().Password !== this.lawFirmData().PasswordRetry) {
            this.statusText('Die eingegebenen Passw&ouml;rter stimmen nicht &uuml;berein.');
            this.hasError(true);
            this.statusVisible(true);
            return false;
        }
        if (this.lawFirmData().Password.toString().includes('"')) {
            this.statusText('Das Kennwort darf kein Anf&uuml;hrungszeichen (") enthalten.');
            this.hasError(true);
            this.statusVisible(true);
            return false;
        }
        if (/^(?=.{12,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/.test(this.lawFirmData().Password.toString()))
            return true;
        this.statusText('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
        this.hasError(true);
        this.statusVisible(true);
        this.lawFirmData().Password("");
        this.lawFirmData().PasswordRetry("");
        return false;
    }
    async setFavorite(keyword, setAsFavorite) {
        RNSAPI.setFavoriteState(keyword, "gericht", setAsFavorite).then((res) => {
            this.getGerichte();
        }).catch((error) => {
            alert("Es ist ein Fehler aufgetreten!");
        });
    }
    async getAppointmentTypesForMakros() {
        await RNSAPI.getAppointmentTypes(false).then((res) => {
            let entrys = res as any;
            this.setAutomationAppointmentTypeOptions(entrys.Payload ?? []);
            this.appointmentTypesForMakros(entrys.Payload.map((r) =>{
                r.actionHandlers = [{
                    icon: "folder-download",
                    name: 'Terminart ausw\u00e4hlen',
                    action: async () => {
                        // this.newMakro().entrys().filter(e => e.typeId() === null)[0].display(null);
                        this.newMakro().entrys().filter(e => e.typeId() === null)[0].removed(null);
                        this.newMakro().entrys().filter(e => e.typeId() === null)[0].typeName(r["Name"]);
                        this.newMakro().entrys().filter(e => e.typeId() === null)[0].typeId(r["TypeId"]);
                    },
                    isSelectionEvent: true
                }]
                return r;
            }));
        }).catch((error) => {
            this.appointmentTypesForMakros([]);
        });
    }
    async getAppointmentTypes() {
        await RNSAPI.getAppointmentTypes(true).then((res) => {
            let entrys = res as any;
            this.setAutomationAppointmentTypeOptions(entrys.Payload ?? []);
            this.appointmentTypes(entrys.Payload.map((a) => {
                a.actionHandlers = [
                    {
                        icon: "pencil-alt",
                        name: "Bearbeiten",
                        action: async () => {
                            this.appointmentModalTitle("Terminart \"" + a.Name + "\" ÄNDERN");
                            this.createAppointmentType(false);
                            this.appointmentType().Id(a.Id);
                            this.appointmentType().Name(a.Name);
                            this.appointmentType().TypeId(a.TypeId);
                            this.appointmentType().SubjectSuggestion(a.SubjectSuggestion);
                            // if (a.ActiveRemoteConfiguration === true)
                            //     (<HTMLInputElement>document.getElementById("isRemotePossible")).checked = true;
                            // else
                            //     (<HTMLInputElement>document.getElementById("isRemotePossible")).checked = false;
                            if (a.Inactive === true)
                                (<HTMLInputElement>document.getElementById("isAppointmentTypeInactive")).checked = true;
                            else
                                (<HTMLInputElement>document.getElementById("isAppointmentTypeInactive")).checked = false;
                            if (a.OutlookShowAsBusy === true)
                                (<HTMLInputElement>document.getElementById("OutlookShowAsBusy")).checked = true;
                            else
                                (<HTMLInputElement>document.getElementById("OutlookShowAsBusy")).checked = false;
                            if (a.HasToBeVerified === true)
                                (<HTMLInputElement>document.getElementById("appointmentVerification")).checked = true;
                            else
                                (<HTMLInputElement>document.getElementById("appointmentVerification")).checked = false;
                            if (a.IsAllDay === true)
                                (<HTMLInputElement>document.getElementById("appointmentAllDay")).checked = true;
                            else
                                (<HTMLInputElement>document.getElementById("appointmentAllDay")).checked = false;



                            $("#appointmentTypeModal").modal('show');
                        }
                    }
                ];

                if (a.HasToBeVerified === true)
                    a.actionHandlers.push({ icon: "check-double", name: "Zu verifizieren", action: async () => { } });

                if (a.Inactive) {
                    a.IsDeleted = true;
                    a.actionHandlers.push({
                        icon: "play",
                        name: "Inaktive Terminart reaktivieren?",
                        action: async () => {
                            this.setAppointmentTypeInactive(a.Id, true);
                        }
                    });
                }
                else {
                    a.actionHandlers.push({
                        icon: "pause",
                        name: "Terminart deaktivieren?",
                        action: async () => {
                            this.setAppointmentTypeInactive(a.Id, false);
                        }
                    });
                }

                a.actionHandlers.reverse();
                return a;
            }))
        }).catch((error) => {
            this.appointmentTypes([]);
        });
    }
    async setAppointmentTypeInactive(typeId: number, active: boolean) {
        await RNSAPI.setAppointmentActivity(typeId, active).then((data) => {
            this.getAppointmentTypes();
        }).catch((error) => {
            console.log(error);
        });
    }

    async saveAppointmentType() {
        if (ko.toJS(this.appointmentType().Name) == "" || ko.toJS(this.appointmentType().TypeId) == "") {
            this.error("Bitte füllen Sie die Pflichtfelder aus!");
        } else {
            try {
                this.appointmentType().OutlookShowAsBusy((<HTMLInputElement>document.getElementById("OutlookShowAsBusy")).checked);
                this.appointmentType().IsAllDay((<HTMLInputElement>document.getElementById("appointmentAllDay")).checked);
                if(ko.toJS(this.hasVerificationRights))
                    this.appointmentType().HasToBeVerified((<HTMLInputElement>document.getElementById("appointmentVerification")).checked);
                else
                    this.appointmentType().HasToBeVerified(false);

                if (ko.toJS(this.appointmentModalTitle) === "Terminart anlegen") {
                    let result = await RNSAPI.addAppointmentType(ko.toJS(this.appointmentType()));
                    this.getAppointmentTypes();
                    if (result !== null) {
                        $('#appointmentTypeModal').modal('hide');
                        return;
                    }
                } else {
                    this.appointmentType().Inactive((<HTMLInputElement>document.getElementById("isAppointmentTypeInactive")).checked);
                    let result = await RNSAPI.updateAppointmentType(ko.toJS(this.appointmentType()));
                    this.getAppointmentTypes();
                    if (result !== null) {
                        $('#appointmentTypeModal').modal('hide');
                        return;
                    }
                }
            } catch (e) {
                console.log(e);
            }
            alert("Die Terminart konnte nicht hinzugefügt werden. Bitte prüfen Sie Ihre Eingaben! (eventuell ist das Kürzel bereits vergeben.)");
        }
    }

    // #region Automation
    // global Properties
    private reportDurationPickSub?: { dispose: () => void };
    allAutomationTasks = ko.observableArray([]);
    currentPage = ko.observable(null);
    showHeaderPart = ko.observable(false);
    isHeaderEditable= ko.observable(false);
    pageTitle: ko.PureComputed<string>;
    canGoBack = ko.observable(false);
    isSummaryPage = ko.observable(false);
    sendMailToAll = ko.observable<boolean>(true);
    additionalMailRecipient = ko.observable<string>("");
    saveToDirectory = ko.observable<boolean>(false);
    directoryPath = ko.observable<string>("");
    selectedLocationIds = ko.observableArray<number>([]);
    sendTime = ko.observable("");
    title = ko.observable("");
    note = ko.observable("");
    selectedAutomationType = ko.observable<number | null>(null);
    reportBindPoint = ko.observable<string>("0");
    periodText = ko.observable<string>("0");
    reportCalcValues: CalcViewModel;
    deadlineCalcValues: CalcViewModel;
    appointmentCalcValues: CalcViewModel;
    currentCalcValues = ko.pureComputed<CalcViewModel>(() => {
        switch (this.currentAutoPage()) {
            case "Report": return this.reportCalcValues;
            case "Deadline": return this.deadlineCalcValues;
            case "Appointment": return this.appointmentCalcValues;
            default: return this.reportCalcValues;
        }
    });
    deadlineStartModeOptions: ModeOption[] = [
        { text: "am", reportModeValues: 0 },
        { text: "vor der", reportModeValues: 1 },
        { text: "nach der", reportModeValues: 2 }
    ];
    deadlineIntervalOptions: IntervalOption[] = [
        { text: "", reportIntervalValues: -1 },
        { text: "Tage", reportIntervalValues: 2 },
        { text: "Wochen", reportIntervalValues: 3 },
        { text: "Monate", reportIntervalValues: 4 }
    ];
    reportOptions = ko.observableArray<{ text: string; reportValues: number }>([]);
    automationReportTypeOptions = ko.observableArray<AutomationReportTypeOption>([]);
    automationAppointmentTypeOptions = ko.observableArray<AutomationAppointmentTypeOption>([]);
    finalSummary = ko.observable<AutomationSummaryDto | null>(null);
    applyToAll = ko.observable<boolean>(false);
    setApplyToAll = (v: boolean) => this.applyToAll(v);

    // ReportReports
    reportsStartAmount = ko.observable<string | number>("");
    reportsStartInterval = ko.observable<number>(-1);
    reportsStartMode = ko.observable<number>(0);
    reportsEndAmount = ko.observable<string | number>("");
    reportsEndInterval = ko.observable<number>(-1);
    reportsEndMode = ko.observable<number>(0);
    reportsRefDateText = ko.observable<string>("");
    reportsAmountIntervalEnabled = ko.observable<boolean>(false);
    reportsModeEnabled = ko.observable<boolean>(true);
    reportType = ko.observable<string>("");
    reportSort = ko.observable<number>(0);

    // ReportDeadline
    deadlineStartAmount = ko.observable<string | number>("");
    deadlineStartInterval = ko.observable<number>(-1);
    deadlineStartMode = ko.observable<number>(0);
    deadlineRefDateText = ko.observable<string>("");
    deadlineAmountIntervalEnabled = ko.observable<boolean>(false);
    deadlineModeEnabled = ko.observable<boolean>(true);

    // ReportAppointment
    appointmentStartAmount = ko.observable<string | number>("");
    appointmentStartInterval = ko.observable<number>(-1);
    appointmentStartMode = ko.observable<number>(0);
    appointmentEndAmount = ko.observable<string | number>("");
    appointmentEndInterval = ko.observable<number>(-1);
    appointmentEndMode = ko.observable<number>(0);
    appointmentRefDateText = ko.observable<string>("");
    appointmentAmountIntervalEnabled = ko.observable<boolean>(false);
    appointmentModeEnabled = ko.observable<boolean>(true);
    appointmentDeliveryTimeType = ko.observable<"1" | "2">("1"); // 1=Individuell, 2=Dynamisch
    appointmentTypesOfAppo = ko.observable<number | null>(null);
    appointmentStatus = ko.observable<number>(0);                // 0/1/2 (siehe Mapping unten)
    sendDateTimeDisplay = ko.observable<string>();
    appointmentIntervalOptions: IntervalOption[] = [
        { text: "", reportIntervalValues: -1 },
        { text: "Minuten", reportIntervalValues: 0 },
        { text: "Stunden", reportIntervalValues: 1 },
        { text: "Tage", reportIntervalValues: 2 },
        { text: "Wochen", reportIntervalValues: 3 },
        { text: "Monate", reportIntervalValues: 4 }
    ];
    appointmentStartModeOptions: ModeOption[] = [
        { text: "am", reportModeValues: 0 },
        { text: "vor dem", reportModeValues: 1 },
    ];
    appointmentEndModeOptions: ModeOption[] = [
        { text: "am", reportModeValues: 0 },
        { text: "nach dem", reportModeValues: 2 }
    ];
    showTypeInTitle = ko.observable(false);
    showErrorTitle = ko.observable(false);
    showErrorTime = ko.observable(false);
    showAmountError = ko.observable(false);
    automationValidationMessage = ko.observable<string>("");
    reportDurationPick = ko.observable("0");
    newAutomation = ko.observable(null);
    newAutomationSaveable = ko.observable(false);
    automationEditId = ko.observable<number | null>(null);
    elementStatus = ko.observable(0);
    taskDuration = ko.observable<number | null>(null);
    weekDayPick = ko.observable<number | null>(null);
    workday = ko.observable({
        first: ko.observable(false),
        last: ko.observable(false)
    });

    // pureComputed Observables
    currentAutoPage = ko.pureComputed(() => {
        switch (this.currentPage()) {
            case 0: return "chooseType";
            case 1: return "setHeader";
            case 2: return "Report";
            case 3: return "Deadline";
            case 4: return "Appointment";
            case 5: return "Summary";
            default: return "";
        }
    });
    selectedAutomationTypeText = ko.pureComputed(() => {
        const baseTypeText = this.selectedAutomationTypeTextByValue(this.selectedAutomationType());
        switch (baseTypeText) {
            case "Auswertung": return "Auswertungs";
            case "Frist": return "Fristen";
            case "Termin": return "Termin";
            default: return "";
        }
    });
    showTaskDuration = ko.pureComputed(() => {
        const pick = this.reportDurationPick();
        return pick !== null && pick === "1";
    });
    showWeekDaySelect = ko.pureComputed(() => {
        const report = this.reportSort();
        return report !== null && report === 1;
    });
    showMonthOptions = ko.pureComputed(() => {
        const report = this.reportSort();
        return report !== null && report === 2;
    });
    isAdditionalRecipientRequired = ko.pureComputed(() => !this.sendMailToAll());
    showApplyToAll = ko.pureComputed(() => {
        const t = this.selectedAutomationType();
        return t === 1 || t === 2; // Deadline/Appointment
    });
    isAppointmentDynamic = ko.pureComputed(() => this.appointmentDeliveryTimeType() === "2");
    showAppointmentSendTime = ko.pureComputed(() => !this.isAppointmentDynamic()); // nur bei Individuell
    showAppointmentDynamicBlock = ko.pureComputed(() => this.isAppointmentDynamic());
    selectedReportType = ko.pureComputed(() =>
        this.automationReportTypeOptions().find(x => x.id === this.reportType()) ?? null);
    selectedReportTypeRequiresCalc = ko.pureComputed(() => {
        const reportType = this.selectedReportType();
        return !!reportType && (reportType.hasCalcStart || reportType.hasCalcEnd);
    });
    automationAppointmentTypeOptionsForSelect = ko.pureComputed(() => {
        const selectedId = this.appointmentTypesOfAppo();
        return this.automationAppointmentTypeOptions()
            .filter(x => !x.inactive || x.id === selectedId)
            .sort((a, b) => a.title.localeCompare(b.title, "de"));
    });

    // Methods
    showAutomation() {
        MainViewModel.RoutingTable.showSettingsView({ view: "automation" }, true);
        this.currentView('automation');
    }
    newAutomationModal() {
        this.resetAutomationForm();
        this.showNotificationTitle(false);
        this.newMakro(this.newAutomationPackage());
        this.currentPage(0);
        $("#automationModal").modal('show');
    }
    newAutomationPackage() {
        return {
            Title: ko.observable(""),
            Note: ko.observable(""),
            SendTime: ko.observable("")
        };
    }
    getNextPage(currPage: string): string | null {
        switch (currPage) {
            case "chooseType":
                return "setHeader";
            case "setHeader":
                switch (this.selectedAutomationType()) {
                    case 0: return "Report";
                    case 1: return "Deadline";
                    case 2: return "Appointment";
                    default: return null;
                }
            case "Report":
            case "Deadline":
            case "Appointment":
                return "Summary";
            default:
                return null;
        }
    }
    switchPage(){
        const currentPage = this.currentAutoPage();
        const nextOne = this.getNextPage(currentPage);
        if (!this.newAutomation()) {
            this.newAutomation(this.newAutomationPackage());
        }
        this.automationValidationMessage("");
        switch (nextOne) {
            case "setHeader":
                this.currentPage(1);
                this.showHeaderPart(true);
                this.isHeaderEditable(true);
                this.canGoBack(true);
                this.isSummaryPage(false);
                break;
            case "Report":
                if (!this.validateHeaderBeforeDetails())
                    return;
                this.showHeaderPart(true);
                this.isHeaderEditable(false);
                this.currentPage(2);
                this.canGoBack(true);
                this.isSummaryPage(false);
                this.updateReportSortOptions();
                this.reportDurationPickSub?.dispose();
                this.reportDurationPickSub = this.reportDurationPick.subscribe(() => this.updateReportSortOptions());
                this.showTaskDuration();
                this.showMonthOptions();
                this.showWeekDaySelect();
                break;
            case "Deadline":
                if (!this.validateHeaderBeforeDetails())
                    return;
                this.showHeaderPart(true);
                this.isHeaderEditable(false);
                this.currentPage(3);
                this.canGoBack(true);
                this.isSummaryPage(false);
                break;
            case "Appointment":
                if (!this.validateHeaderBeforeDetails())
                    return;
                this.showHeaderPart(true);
                this.isHeaderEditable(false);
                this.currentPage(4);
                this.canGoBack(true);
                this.isSummaryPage(false);
                break;
            case "Summary":
                if (!this.validateBeforeSummary())
                    return;
                this.finalSummary(this.buildSummary());
                this.showHeaderPart(false);
                this.isHeaderEditable(false);
                this.currentPage(5);
                this.canGoBack(true);
                this.isSummaryPage(true);
                break;
            default:
                console.log("Default Fall: Hier stimmt was nicht - " + this.currentAutoPage());
                this.canGoBack(false);
                this.isSummaryPage(false);
        }
    }
    goBack() {
        const page = this.currentPage();
        if (page == 0){
            this.canGoBack(false);
            this.isSummaryPage(false);
            this.showHeaderPart(false);
            return this.currentPage(0);
        }

        if (page == 1){
            this.canGoBack(false);
            this.isSummaryPage(false);
            this.showHeaderPart(false);
            return this.currentPage(0);
        }

        if (page == 2 || page == 3 || page == 4){
            this.canGoBack(true);
            this.isSummaryPage(false);
            this.showHeaderPart(true);
            this.isHeaderEditable(true);
            return this.currentPage(1);
        }

        if (page == 5){
            console.log("Summary Page" + this.selectedAutomationType());
            const type = this.selectedAutomationType(); // 0/1/2

            this.canGoBack(true);
            this.isSummaryPage(false);
            this.showHeaderPart(true);
            this.isHeaderEditable(false);

            if (type === 0) return this.currentPage(2); // Report
            if (type === 1) return this.currentPage(3); // Deadline
            if (type === 2) return this.currentPage(4); // Appointment

            // fallback
            return this.currentPage(0);
        }
    }
    selectAutomationType = (autoType: number) => {
        this.selectedAutomationType(autoType);
    };
    private resetCalcValues(calc: CalcViewModel) {
        calc.reportStartAmount("");
        calc.reportStartInterval(-1);
        calc.reportStartMode(0);
        calc.reportEndAmount("");
        calc.reportEndInterval(-1);
        calc.reportEndMode(0);
    }
    private resetAutomationForm() {
        this.automationEditId(null);
        this.newAutomation(this.newAutomationPackage());
        this.currentPage(0);
        this.canGoBack(false);
        this.isSummaryPage(false);
        this.showHeaderPart(false);
        this.isHeaderEditable(false);
        this.selectedAutomationType(null);
        this.sendMailToAll(true);
        this.additionalMailRecipient("");
        this.saveToDirectory(false);
        this.directoryPath("");
        this.selectedLocationIds([]);
        this.sendTime("");
        this.reportBindPoint("0");
        this.sendDateTimeDisplay("");
        this.applyToAll(false);
        this.reportType("");
        this.reportSort(0);
        this.elementStatus(0);
        this.taskDuration(null);
        this.weekDayPick(null);
        this.workday().first(false);
        this.workday().last(false);
        this.reportDurationPick("0");
        this.appointmentDeliveryTimeType("1");
        this.appointmentTypesOfAppo(null);
        this.appointmentStatus(0);
        this.resetCalcValues(this.reportCalcValues);
        this.resetCalcValues(this.deadlineCalcValues);
        this.resetCalcValues(this.appointmentCalcValues);
        this.finalSummary(null);
        this.showErrorTitle(false);
        this.showErrorTime(false);
        this.showAmountError(false);
        this.automationValidationMessage("");
    }
    private registerAutomationModalReset() {
        $("#automationModal")
            .off("hidden.bs.modal.automationReset")
            .on("hidden.bs.modal.automationReset", () => {
                this.resetAutomationForm();
            });
    }
    private applyCalcToViewModel(calc: CalcViewModel, value?: AutomationCalcResponse | null) {
        this.resetCalcValues(calc);
        if (value?.start) {
            calc.reportStartAmount(value.start.amount ?? "");
            calc.reportStartInterval(value.start.interval);
            calc.reportStartMode(value.start.mode);
        }
        if (value?.end) {
            calc.reportEndAmount(value.end.amount ?? "");
            calc.reportEndInterval(value.end.interval);
            calc.reportEndMode(value.end.mode);
        }
    }
    private normalizeAutomationCalcValue(value: any): AutomationCalcResponse | null {
        if (!value)
            return null;

        const start = value.start ?? value.Start;
        const end = value.end ?? value.End;

        const normalizePart = (part: any) => {
            if (!part)
                return null;

            return {
                amount: part.amount ?? part.Amount ?? null,
                interval: Number(part.interval ?? part.Interval ?? -1),
                mode: Number(part.mode ?? part.Mode ?? 0)
            };
        };

        return {
            start: normalizePart(start),
            end: normalizePart(end)
        };
    }
    private normalizeAutomationTask(task: any): AutomationTaskResponse {
        const reportRaw = task?.report ?? task?.Report ?? null;
        const deadlineRaw = task?.deadline ?? task?.Deadline ?? null;
        const appointmentRaw = task?.appointment ?? task?.Appointment ?? null;

        return {
            id: task?.id ?? task?.Id,
            title: task?.title ?? task?.Title ?? "",
            note: task?.note ?? task?.Note ?? "",
            automationType: Number(task?.automationType ?? task?.AutomationType ?? -1),
            sendMailToAll: !!(task?.sendMailToAll ?? task?.SendMailToAll),
            additionalMailRecipient: task?.additionalMailRecipient ?? task?.AdditionalMailRecipient ?? "",
            applyToAll: task?.applyToAll ?? task?.ApplyToAll ?? null,
            isActive: task?.isActive ?? task?.IsActive ?? true,
            saveToDirectory: task?.saveToDirectory ?? task?.SaveToDirectory ?? false,
            directoryPath: task?.directoryPath ?? task?.DirectoryPath ?? "",
            locationIds: (task?.locationIds ?? task?.LocationIds ?? []) as number[],
            report: reportRaw ? {
                reportDurationPick: String(reportRaw.reportDurationPick ?? reportRaw.ReportDurationPick ?? "0"),
                taskDuration: reportRaw.taskDuration ?? reportRaw.TaskDuration ?? null,
                reportSort: Number(reportRaw.reportSort ?? reportRaw.ReportSort ?? 0),
                sendTime: this.normalizeSendTime24h(reportRaw.sendTime ?? reportRaw.SendTime ?? ""),
                weekDayPick: reportRaw.weekDayPick ?? reportRaw.WeekDayPick ?? null,
                workdayFirst: !!(reportRaw.workdayFirst ?? reportRaw.WorkdayFirst),
                workdayLast: !!(reportRaw.workdayLast ?? reportRaw.WorkdayLast),
                reportType: reportRaw.reportType ?? reportRaw.ReportType ?? "",
                elementStatus: Number(reportRaw.elementStatus ?? reportRaw.ElementStatus ?? 0),
                calc: this.normalizeAutomationCalcValue(reportRaw.calc ?? reportRaw.Calc)
            } : null,
            deadline: deadlineRaw ? {
                sendTime: this.normalizeSendTime24h(deadlineRaw.sendTime ?? deadlineRaw.SendTime ?? ""),
                elementStatus: Number(deadlineRaw.elementStatus ?? deadlineRaw.ElementStatus ?? 0),
                calc: this.normalizeAutomationCalcValue(deadlineRaw.calc ?? deadlineRaw.Calc)
            } : null,
            appointment: appointmentRaw ? {
                bindPoint: String(appointmentRaw.bindPoint ?? appointmentRaw.BindPoint ?? "0"),
                appointmentTypeId: appointmentRaw.appointmentTypeId ?? appointmentRaw.AppointmentTypeId ?? null,
                status: Number(appointmentRaw.status ?? appointmentRaw.Status ?? 0),
                deliveryTimeType: String(appointmentRaw.deliveryTimeType ?? appointmentRaw.DeliveryTimeType ?? "1"),
                sendTime: this.normalizeSendTime24h(appointmentRaw.sendTime ?? appointmentRaw.SendTime ?? ""),
                calc: this.normalizeAutomationCalcValue(appointmentRaw.calc ?? appointmentRaw.Calc)
            } : null
        };
    }
    private applyAutomationToForm(task: AutomationTaskResponse) {
        const normalizedTask = this.normalizeAutomationTask(task);
        this.resetAutomationForm();
        this.automationEditId(normalizedTask.id ?? null);
        this.newAutomation({
            Title: ko.observable(normalizedTask.title ?? ""),
            Note: ko.observable(normalizedTask.note ?? ""),
            SendTime: ko.observable("")
        });
        this.sendMailToAll(!!normalizedTask.sendMailToAll);
        this.additionalMailRecipient(normalizedTask.additionalMailRecipient ?? "");
        this.saveToDirectory(!!normalizedTask.saveToDirectory);
        this.directoryPath(normalizedTask.directoryPath ?? "");
        this.selectedLocationIds(Array.isArray(normalizedTask.locationIds) ? normalizedTask.locationIds : []);
        this.applyToAll(!!normalizedTask.applyToAll);
        this.selectedAutomationType(normalizedTask.automationType);

        if (normalizedTask.automationType === 0 && normalizedTask.report) {
            this.reportDurationPick(normalizedTask.report.reportDurationPick ?? "0");
            this.taskDuration(normalizedTask.report.taskDuration ?? null);
            this.reportSort(Number(normalizedTask.report.reportSort ?? 0));
            this.sendTime(normalizedTask.report.sendTime ?? "");
            this.weekDayPick(normalizedTask.report.weekDayPick ?? null);
            this.workday().first(!!normalizedTask.report.workdayFirst);
            this.workday().last(!!normalizedTask.report.workdayLast);
            this.reportType(normalizedTask.report.reportType ?? "");
            this.elementStatus(Number(normalizedTask.report.elementStatus ?? 0));
            this.applyCalcToViewModel(this.reportCalcValues, normalizedTask.report.calc ?? null);
        }

        if (normalizedTask.automationType === 1 && normalizedTask.deadline) {
            this.sendTime(normalizedTask.deadline.sendTime ?? "");
            this.elementStatus(Number(normalizedTask.deadline.elementStatus ?? 0));
            this.applyCalcToViewModel(this.deadlineCalcValues, normalizedTask.deadline.calc ?? null);
        }

        if (normalizedTask.automationType === 2 && normalizedTask.appointment) {
            this.appointmentDeliveryTimeType((normalizedTask.appointment.deliveryTimeType ?? "1") as "1" | "2");
            this.appointmentTypesOfAppo(
                normalizedTask.appointment.appointmentTypeId != null
                    ? Number(normalizedTask.appointment.appointmentTypeId)
                    : null
            );
            this.appointmentStatus(Number(normalizedTask.appointment.status ?? 0));
            this.sendTime(normalizedTask.appointment.sendTime ?? "");
            this.reportBindPoint(normalizedTask.appointment.bindPoint ?? "0");
            this.applyCalcToViewModel(this.appointmentCalcValues, normalizedTask.appointment.calc ?? null);
        }

        this.updateReportSortOptions();
    }
    openEditAutomationModal = (task: AutomationTaskResponse) => {
        this.applyAutomationToForm(task);
        this.showHeaderPart(true);
        this.isHeaderEditable(true);
        this.canGoBack(true);
        this.isSummaryPage(false);
        switch (task.automationType) {
            case 0:
                this.currentPage(2);
                break;
            case 1:
                this.currentPage(3);
                break;
            case 2:
                this.currentPage(4);
                break;
            default:
                this.currentPage(1);
                break;
        }
        $("#automationModal").modal("show");
    };
    setAutomationActivity = async (task: AutomationTaskResponse, active: boolean) => {
        if (task.id == null)
            return;

        try {
            await RNSAPI.setAutomationTaskActivity(task.id, active);
            await this.getAllAutomationTasks();
            this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
            this.statusModalText(active
                ? 'Die Automation wurde aktiviert.'
                : 'Die Automation wurde deaktiviert.');
            $("#statusModal").modal('show');
        } catch (error) {
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler');
            this.statusModalText(active
                ? 'Die Automation konnte nicht aktiviert werden.'
                : 'Die Automation konnte nicht deaktiviert werden.');
            $("#statusModal").modal('show');
        }
    };
    updateSendTime = () => {
        const calc = this.appointmentCalcValues;
        const bindPoint = Number(this.reportBindPoint());
        const base = moment().startOf("day"); //today
        if (bindPoint === 0) base.hours(14).minutes(0);
        else base.hours(15).minutes(0);
        const amount = Number(bindPoint === 0 ? calc.reportStartAmount() : calc.reportEndAmount());
        const interval = Number(bindPoint === 0? calc.reportStartInterval(): calc.reportEndInterval());
        const mode = Number(bindPoint === 0 ? calc.reportStartMode() : calc.reportEndMode());

        if (isNaN(amount) || isNaN(interval)) {
            this.sendDateTimeDisplay(base.format("YYYY-MM-DDTHH:mm"));
            return;
        }

        let effectiveAmount = amount;
        if (mode === 0) {
            effectiveAmount = 0;          // Am
        } else if (mode === 1) {
            effectiveAmount = -amount;    // vor dem
        }
        // mode === 2 → nach dem

        switch (interval) {
            case 0: base.add(effectiveAmount, "minutes"); break;
            case 1: base.add(effectiveAmount, "hours"); break;
            case 2: base.add(effectiveAmount, "days"); break;
            case 3: base.add(effectiveAmount, "weeks"); break;
            case 4: base.add(effectiveAmount, "months"); break;
        }

        this.sendDateTimeDisplay(base.format("YYYY-MM-DDTHH:mm"));
    };
    updateReportSortOptions = () => {
        const pick = this.reportDurationPick();
        this.reportOptions(
            pick === "1"
                ? [
                    { text: "Tage", reportValues: 0 },
                    { text: "Wochen", reportValues: 1 },
                    { text: "Monaten", reportValues: 2 }
                ]
                : [
                    { text: "Tag", reportValues: 0 },
                    { text: "Woche", reportValues: 1 },
                    { text: "Monat", reportValues: 2 }
                ]
        );
    };

    //Helper
    private findTextByValue <T extends { text: string }>(
        arr: T[],
        predicate: (x: T) => boolean): string {
        return arr.find(predicate)?.text ?? "";
    }
    private toSummaryCalc(calc: CalcViewModel): SummaryCalc {
        const toIntervalText = (v: number) =>
            this.findTextByValue(calc.intervalOptions, x => (x as any).reportIntervalValues === v);
        const toModeText = (opts: ModeOption[], v: number) =>
            this.findTextByValue(opts, x => x.reportModeValues === v);
        const start = calc.showStartRow() ? {
                label: calc.fromLabelText(),
                amount: String(calc.reportStartAmount() ?? ""),
                intervalText: toIntervalText(Number(calc.reportStartInterval())),
                modeText: toModeText(calc.startModeOptions, Number(calc.reportStartMode()))
            }
            : null;
        const end = calc.showEndRow() ? {
                label: calc.toLabelText(),
                amount: String(calc.reportEndAmount() ?? ""),
                intervalText: toIntervalText(Number(calc.reportEndInterval())),
                modeText: toModeText(calc.endModeOptions, Number(calc.reportEndMode()))
            }
            : null;
        return { refDatePlaceholder: calc.refDatePlaceholder ?? "", refDateText: calc.refDateText?.() ?? "", start, end };
    }
    private toSummaryCalcFromResponse(calc: AutomationCalcResponse | null | undefined, viewModel: CalcViewModel): SummaryCalc {
        const toIntervalText = (v: number | null | undefined) =>
            this.findTextByValue(viewModel.intervalOptions, x => (x as any).reportIntervalValues === Number(v));
        const toModeText = (opts: ModeOption[], v: number | null | undefined) =>
            this.findTextByValue(opts, x => x.reportModeValues === Number(v));
        const start = calc?.start ? {
                label: viewModel.fromLabelText(),
                amount: String(calc.start.amount ?? ""),
                intervalText: toIntervalText(calc.start.interval),
                modeText: toModeText(viewModel.startModeOptions, calc.start.mode)
            }
            : null;
        const end = calc?.end ? {
                label: viewModel.toLabelText(),
                amount: String(calc.end.amount ?? ""),
                intervalText: toIntervalText(calc.end.interval),
                modeText: toModeText(viewModel.endModeOptions, calc.end.mode)
            }
            : null;
        return {
            refDatePlaceholder: viewModel.refDatePlaceholder ?? "",
            refDateText: viewModel.refDateText?.() ?? "",
            start,
            end
        };
    }
    private buildPeriodText(calc: SummaryCalc | null): string {
        if (!calc) return "";
        const ref = (calc.refDateText || calc.refDatePlaceholder || "Referenzdatum").trim();
        const start = calc.start;
        const end = calc.end;
        const part = (row: SummaryCalcRow) => {
            const modeRaw = (row.modeText ?? "").trim();
            const mode = modeRaw.toLowerCase();
            if (mode === "am") return `am ${ref}`;
            const amount = (row.amount ?? "").trim();
            const interval = (row.intervalText ?? "").trim();
            if (!modeRaw) return "";
            if (!amount || !interval) return `${modeRaw} ${ref}`.trim();

            return `${amount} ${interval} ${modeRaw} ${ref}`.trim();
        };

        if (start && !end) return part(start);
        if (!start && end) return part(end);
        if (start && end) {
            const left = part(start);
            const right = part(end);
            if (left === `am ${ref}` && right === `am ${ref}`) return `am ${ref}`;

            return `${left} – ${right}`;
        }
        return "";
    }
    private deadlineStatusToText(v: number): string {
        const n = Number(v);
        switch (n) {
            case 0: return "Alle";
            case 1: return "Erledigte";
            case 2: return "Unerledigte";
            default: return "";
        }
    }
    private appointmentTypesToText(v: number | string | null | undefined): string {
        if (v == null || v === "")
            return "Alle Terminarten";

        const n = Number(v);
        return this.automationAppointmentTypeOptions().find(x => x.id === n)?.title ?? "";
    }
    private buildDeliveryTextReport(): string {
        const time = (this.sendTime() || "").trim();
        const pick = this.reportDurationPick();
        const unit = this.reportOptions().find(x =>
            x.reportValues === this.reportSort())?.text ?? "";
        if (pick === "0") { // "Jede(n)"
            const normalized = this.buildReportCycleText(
                this.reportSort(),
                this.weekDayPick(),
                !!this.workday().first(),
                !!this.workday().last()
            );
            return time ? `${normalized} um ${time} Uhr` : normalized;
        }

        // "Eigene..."
        const amount = this.taskDuration();
        const amountText = amount != null ? String(amount) : "";

        //"Tage/Wochen/Monate".
        const plural = unit;

        const cycleSuffix = this.buildReportCycleSuffix(
            this.reportSort(),
            this.weekDayPick(),
            !!this.workday().first(),
            !!this.workday().last()
        );
        const base = `Im Abstand von ${amountText} ${plural}${cycleSuffix}`.trim();
        return time ? `${base} um ${time} Uhr` : base;
    }
    private reportTypeToText(t: string): string {
        return this.automationReportTypeOptions().find(x => x.id === t)?.title ?? "";
    }
    private buildDeliveryTextDeadline(): string {
        const time = (this.sendTime() || "").trim();
        return this.buildDeadlineDeliveryText(this.toSummaryCalc(this.deadlineCalcValues), time);
    }
    private buildDeliveryTextAppointment(): string {
        const base =
            this.reportBindPoint() === "0" ? "Ausgehend von Termin-Start" : "Ausgehend von Termin-Ende";
        return base;
    }
    private reportUnitText(durationPick: string | null | undefined, reportSort: number | null | undefined): string {
        const useCustomDuration = durationPick === "1";
        switch (Number(reportSort)) {
            case 0: return useCustomDuration ? "Tage" : "Tag";
            case 1: return useCustomDuration ? "Wochen" : "Woche";
            case 2: return useCustomDuration ? "Monaten" : "Monat";
            default: return "";
        }
    }
    private buildDeliveryTextReportFromTask(report?: AutomationTaskResponse["report"] | null): string {
        if (!report)
            return "";

        const time = (report.sendTime || "").trim();
        const pick = report.reportDurationPick ?? "0";
        const unit = this.reportUnitText(pick, report.reportSort ?? 0);

        if (pick === "0") {
            const normalized = this.buildReportCycleText(
                report.reportSort,
                report.weekDayPick,
                !!report.workdayFirst,
                !!report.workdayLast
            );
            return time ? `${normalized} um ${time} Uhr` : normalized;
        }

        const amount = report.taskDuration != null ? String(report.taskDuration) : "";
        const cycleSuffix = this.buildReportCycleSuffix(
            report.reportSort,
            report.weekDayPick,
            !!report.workdayFirst,
            !!report.workdayLast
        );
        const base = `Im Abstand von ${amount} ${unit}${cycleSuffix}`.trim();
        return time ? `${base} um ${time} Uhr` : base;
    }
    private buildReportCycleText(
        reportSort: number | null | undefined,
        weekDayPick: number | null | undefined,
        workdayFirst: boolean,
        workdayLast: boolean
    ): string {
        switch (Number(reportSort)) {
            case 0:
                return "Jeden Tag";
            case 1: {
                const day = this.weekDayToText(weekDayPick ?? null);
                return day ? `Jede Woche am ${day}` : "Jede Woche";
            }
            case 2:
                if (workdayFirst) return "Jeden Monat am 1. Werktag";
                if (workdayLast) return "Jeden Monat am letzten Werktag";
                return "Jeden Monat";
            default:
                return "Jeden Zeitraum";
        }
    }
    private buildReportCycleSuffix(
        reportSort: number | null | undefined,
        weekDayPick: number | null | undefined,
        workdayFirst: boolean,
        workdayLast: boolean
    ): string {
        switch (Number(reportSort)) {
            case 1: {
                const day = this.weekDayToText(weekDayPick ?? null);
                return day ? ` am ${day}` : "";
            }
            case 2:
                if (workdayFirst) return " am 1. Werktag";
                if (workdayLast) return " am letzten Werktag";
                return "";
            default:
                return "";
        }
    }
    private buildDeliveryTextDeadlineFromTask(deadline?: AutomationTaskResponse["deadline"] | null): string {
        const time = (deadline?.sendTime || "").trim();
        const calc = this.toSummaryCalcFromResponse(deadline?.calc ?? null, this.deadlineCalcValues);
        return this.buildDeadlineDeliveryText(calc, time);
    }
    private buildDeadlineDeliveryText(calc: SummaryCalc | null, sendTime: string): string {
        const base = this.buildDeadlineOffsetText(calc);
        const time = (sendTime || "").trim();
        return time ? `${base} um ${time} Uhr` : base;
    }
    private buildDeadlineOffsetText(calc: SummaryCalc | null): string {
        const start = calc?.start;
        if (!start)
            return "Am Tag der Frist";

        const mode = (start.modeText || "").trim().toLowerCase();
        const amount = (start.amount || "").trim();
        const interval = (start.intervalText || "").trim();

        if (mode === "am")
            return "Am Tag der Frist";

        if (!amount || !interval) {
            if (mode.includes("vor")) return "Vor der Frist";
            if (mode.includes("nach")) return "Nach der Frist";
            return "Am Tag der Frist";
        }

        if (mode.includes("vor"))
            return `${amount} ${interval} vor der Frist`;

        if (mode.includes("nach"))
            return `${amount} ${interval} nach der Frist`;

        return "Am Tag der Frist";
    }
    private buildDeliveryTextAppointmentFromTask(appointment?: AutomationTaskResponse["appointment"] | null): string {
        if (!appointment)
            return "";

        const deliveryType = appointment.deliveryTimeType ?? "1";
        if (deliveryType === "1") {
            const time = (appointment.sendTime || "").trim();
            return time ? `Individuell um ${time} Uhr` : "Individuell";
        }

        const bindPointText = appointment.bindPoint === "1" ? "Termin-Ende" : "Termin-Start";
        const calc = this.toSummaryCalcFromResponse(appointment.calc ?? null, this.appointmentCalcValues);
        const periodText = this.buildPeriodText(calc);
        if (periodText)
            return `Dynamisch: ${periodText} (${bindPointText})`;

        return `Dynamisch (${bindPointText})`;
    }
    private buildDeliveryTextForTask(task: AutomationTaskResponse): string {
        switch (task.automationType) {
            case 0: return this.buildDeliveryTextReportFromTask(task.report);
            case 1: return this.buildDeliveryTextDeadlineFromTask(task.deadline);
            case 2: return this.buildDeliveryTextAppointmentFromTask(task.appointment);
            default: return "";
        }
    }
    private weekDayToText(v: number | null): string {
        switch (Number(v)) {
            case 1: return "Montag";
            case 2: return "Dienstag";
            case 3: return "Mittwoch";
            case 4: return "Donnerstag";
            case 5: return "Freitag";
            case 6: return "Samstag";
            case 7: return "Sonntag";
            default: return "";
        }
    }
    private reportFrequencyToText(pick: string): string {
        return pick === "1" ? "Eigene Angabe" : "Standardintervall";
    }
    private reportSortToText(reportSort: number): string {
        return this.reportOptions().find(x => x.reportValues === reportSort)?.text ?? "";
    }
    private workdayToText(first: boolean, last: boolean): string {
        if (first) return "1. Werktag";
        if (last) return "Letzter Werktag";
        return "";
    }
    private locationIdsToText(locationIds: number[]): string {
        if (!Array.isArray(locationIds) || locationIds.length === 0)
            return "Alle Standorte";

        const options = this.locationOptions() as Array<{ Id: number | null; Name: string }>;
        const names = locationIds
            .map(id => options.find(option => option.Id === id)?.Name)
            .filter((name): name is string => !!name);

        if (names.length === 0)
            return "Ausgewählte Standorte";

        return names.join(", ");
    }
    private appointmentStatusToText(v: number): string {
        switch (Number(v)) {
            case 0: return "Unerledigte";
            case 1: return "Erledigte";
            case 2: return "Alle";
            default: return "";
        }
    }
    private buildSummary(): AutomationSummaryDto {
        const header: HeaderSummary = {
            title: this.newAutomation()?.Title?.() ?? "",
            note: this.newAutomation()?.Note?.() ?? "",
            automationTypeText: this.selectedAutomationTypeTextByValue(this.selectedAutomationType()),
            applyToAllText: this.showApplyToAll()
                ? (this.applyToAll() ? "Ja" : "Nein")
                : "Nicht relevant"
        };
        const mail: MailSummary = {
            sendMailToAll: this.sendMailToAll(),
            additionalMailRecipient: this.additionalMailRecipient(),
            saveToDirectory: this.saveToDirectory(),
            directoryPath: this.directoryPath(),
            locationText: this.locationIdsToText(this.selectedLocationIds().slice())
        };
        const type = this.selectedAutomationType();
        const dto: AutomationSummaryDto = {
            header,
            type,
            mail,
            report: null,
            deadline: null,
            appointment: null
        };
        // Report
        if (type === 0) {
            const calc = this.selectedReportTypeRequiresCalc() ? this.toSummaryCalc(this.reportCalcValues) : null;

            dto.report = {
                frequencyPick: this.reportDurationPick(),
                taskDuration: this.taskDuration(),
                reportSort: this.reportSort(),
                sendTime: this.sendTime(),
                weekDayPick: this.weekDayPick(),
                workdayFirst: this.workday().first(),
                workdayLast: this.workday().last(),
                reportType: this.reportType(),
                elementStatus: this.elementStatus(),
                calc,

                deliveryText: this.buildDeliveryTextReport(),
                typeText: this.reportTypeToText(this.reportType()),
                statusText: this.deadlineStatusToText(Number(this.elementStatus())),
                reportSortText: this.reportSortToText(Number(this.reportSort())),
                frequencyText: this.reportFrequencyToText(this.reportDurationPick()),
                weekDayText: this.weekDayToText(this.weekDayPick()),
                workdayText: this.workdayToText(this.workday().first(), this.workday().last()),
                periodText: this.buildPeriodText(calc)
            };
        }
        // Deadline
        if (type === 1) {
            const status = this.elementStatus();
            dto.deadline = {
                sendTime: this.sendTime(),
                elementStatus: status,
                statusText:this.deadlineStatusToText(status),
                deliveryText: this.buildDeliveryTextDeadline()
            };
        }
        // Appointment
        if (type === 2) {
            const calc = this.toSummaryCalc(this.appointmentCalcValues);

            const deliveryType = this.appointmentDeliveryTimeType(); // "1"/"2"
            const status = Number(this.appointmentStatus());
            const types = this.appointmentTypesOfAppo();

            dto.appointment = {
                deliveryTimeType: deliveryType, // raw
                deliveryTimeTypeText: deliveryType === "1" ? "Individuell" : "Dynamisch",

                typesOfAppo: types ?? 0,
                typesText: this.appointmentTypesToText(types),

                status,
                statusText: this.appointmentStatusToText(status),

                // Individuell: Uhrzeit anzeigen, Dynamisch: nicht
                sendTime: deliveryType === "1" ? (this.sendTime() || "").trim() : "",

                bindPoint: this.reportBindPoint(),
                bindPointText: this.reportBindPoint() === "0" ? "Termin-Start" : "Termin-Ende",

                calc,
                periodText: this.buildPeriodText(calc)
            };
        }
        return dto;
    }
    private serializeCalc(calc: CalcViewModel): CalcDto {
        const makePart = (amountObs: any, intervalObs: any, modeObs: any) => {
            const mode = Number(modeObs());
            const interval = Number(intervalObs());
            const amountRaw = amountObs();
            if (mode === 0) {
                return { amount: null, interval: -1, mode };
            }
            const amount = amountRaw === "" || amountRaw == null ? null : Number(amountRaw);
            return {
                amount: Number.isFinite(amount as any) ? (amount as number) : null,
                interval,
                mode
            };
        };
        const dto: CalcDto = { start: null, end: null };
        if (calc.showStartRow()) {
            dto.start = makePart(calc.reportStartAmount, calc.reportStartInterval, calc.reportStartMode);
        }
        if (calc.showEndRow()) {
            dto.end = makePart(calc.reportEndAmount, calc.reportEndInterval, calc.reportEndMode);
        }
        return dto;
    }

    private validateMail(): boolean {
        const sendAll = !!this.sendMailToAll();
        const additional = (this.additionalMailRecipient() || "").trim();
        if (!sendAll && additional.length === 0)
            return false;

        return true;
    }
    private validateHeaderBeforeDetails(): boolean {
        const title = (this.newAutomation()?.Title?.() ?? "").trim();
        this.showErrorTitle(title.length === 0);
        if (title.length === 0) {
            this.automationValidationMessage("Bitte geben Sie einen Titel an.");
            return false;
        }

        this.automationValidationMessage("");
        return true;
    }
    private isCalcRowComplete(amount: string | number | null | undefined, interval: number, mode: number): boolean {
        if (mode === 0)
            return true;

        const value = Number(amount);
        return Number.isFinite(value) && value > 0 && interval >= 0;
    }
    private validateCalcForSummary(calc: CalcViewModel): boolean {
        const startValid = !calc.showStartRow() || this.isCalcRowComplete(calc.reportStartAmount(), Number(calc.reportStartInterval()), Number(calc.reportStartMode()));
        const endValid = !calc.showEndRow() || this.isCalcRowComplete(calc.reportEndAmount(), Number(calc.reportEndInterval()), Number(calc.reportEndMode()));
        return startValid && endValid;
    }
    private normalizeSendTime24h(raw: string | null | undefined): string {
        const value = (raw || "").trim();
        if (value.length === 0)
            return "";

        const m24 = value.match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
        if (m24) {
            const hour = Number(m24[1]);
            const minute = Number(m24[2]);
            return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        }

        const m12 = value.match(/^(\d{1,2}):([0-5]\d)\s*([AaPp][Mm])$/);
        if (m12) {
            let hour = Number(m12[1]);
            const minute = Number(m12[2]);
            const suffix = m12[3].toUpperCase();
            if (hour >= 1 && hour <= 12) {
                if (suffix === "PM" && hour < 12)
                    hour += 12;
                if (suffix === "AM" && hour === 12)
                    hour = 0;
                return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
            }
        }

        return value;
    }
    private isValidSendTime24h(raw: string | null | undefined): boolean {
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test((raw || "").trim());
    }
    private validateBeforeSummary(): boolean {
        this.showErrorTitle(false);
        this.showErrorTime(false);
        this.showAmountError(false);
        this.automationValidationMessage("");

        if (!this.validateHeaderBeforeDetails())
            return false;

        const normalizedSendTime = this.normalizeSendTime24h(this.sendTime());
        if (normalizedSendTime.length > 0)
            this.sendTime(normalizedSendTime);

        const type = Number(this.selectedAutomationType());
        if (type === 0) {
            const sendTime = (this.sendTime() || "").trim();
            if (sendTime.length === 0) {
                this.showErrorTime(true);
                this.automationValidationMessage("Bitte geben Sie die Uhrzeit für den Versand an.");
                return false;
            }
            if (!this.isValidSendTime24h(sendTime)) {
                this.showErrorTime(true);
                this.automationValidationMessage("Bitte geben Sie die Uhrzeit im Format HH:mm an.");
                return false;
            }
            if ((this.reportType() || "").trim().length === 0) {
                this.automationValidationMessage("Bitte wählen Sie einen Auswertungstyp aus.");
                return false;
            }
            if (this.reportDurationPick() === "1") {
                const amount = Number(this.taskDuration());
                if (!Number.isFinite(amount) || amount < 2) {
                    this.showAmountError(true);
                    this.automationValidationMessage("Bitte geben Sie einen gültigen Abstand (mindestens 2) an.");
                    return false;
                }
            }
            if (Number(this.reportSort()) === 1 && (this.weekDayPick() == null || Number(this.weekDayPick()) <= 0)) {
                this.automationValidationMessage("Bitte wählen Sie einen Wochentag aus.");
                return false;
            }
            if (this.selectedReportTypeRequiresCalc() && !this.validateCalcForSummary(this.reportCalcValues)) {
                this.automationValidationMessage("Bitte füllen Sie die Berechnungslogik vollständig aus.");
                return false;
            }
        }
        if (type === 1) {
            const sendTime = (this.sendTime() || "").trim();
            if (sendTime.length === 0) {
                this.showErrorTime(true);
                this.automationValidationMessage("Bitte geben Sie die Uhrzeit für den Versand an.");
                return false;
            }
            if (!this.isValidSendTime24h(sendTime)) {
                this.showErrorTime(true);
                this.automationValidationMessage("Bitte geben Sie die Uhrzeit im Format HH:mm an.");
                return false;
            }
            if (!this.validateCalcForSummary(this.deadlineCalcValues)) {
                this.automationValidationMessage("Bitte füllen Sie die Berechnungslogik vollständig aus.");
                return false;
            }
        }
        if (type === 2) {
            const dynamic = this.appointmentDeliveryTimeType() === "2";
            if (!dynamic) {
                const sendTime = (this.sendTime() || "").trim();
                if (sendTime.length === 0) {
                    this.showErrorTime(true);
                    this.automationValidationMessage("Bitte geben Sie die Uhrzeit für den Versand an.");
                    return false;
                }
                if (!this.isValidSendTime24h(sendTime)) {
                    this.showErrorTime(true);
                    this.automationValidationMessage("Bitte geben Sie die Uhrzeit im Format HH:mm an.");
                    return false;
                }
            }
            if (dynamic && !this.validateCalcForSummary(this.appointmentCalcValues)) {
                this.automationValidationMessage("Bitte füllen Sie die Berechnungslogik vollständig aus.");
                return false;
            }
        }

        if (!this.validateMail()) {
            this.automationValidationMessage("Bitte geben Sie zusätzliche Empfänger an oder aktivieren Sie den Versand an alle Verfahrensbearbeiter.");
            return false;
        }

        if (!!this.saveToDirectory() && (this.directoryPath() || "").trim().length === 0) {
            this.automationValidationMessage("Bitte geben Sie ein Verzeichnis für die Ablage an.");
            return false;
        }

        return true;
    }

    // Methods From/To Backend
    saveAutomation = async () => {
        this.showErrorTitle(false);
        this.showErrorTime(false);
        this.showAmountError(false);
        if (!this.validateBeforeSummary())
            return;

        const isEdit = this.automationEditId() != null;
        const type = Number(this.selectedAutomationType());
        const title = (this.newAutomation()?.Title?.() ?? "").trim();
        const note = (this.newAutomation()?.Note?.() ?? "").trim();
        const applyToAllValue = (type === 1 || type === 2) ? this.applyToAll?.() ?? null : undefined;

        // Build payload
        const payload: AutomationPayload = {
            id: this.automationEditId() ?? undefined,
            title,
            note,
            automationType: type,
            sendMailToAll: !!this.sendMailToAll(),
            additionalMailRecipient: (this.additionalMailRecipient() || "").trim(),
            applyToAll: applyToAllValue,
            saveToDirectory: !!this.saveToDirectory(),
            directoryPath: (this.directoryPath() || "").trim(),
            locationIds: this.selectedLocationIds().slice()
        };
        // Report
        if (type === 0) {
            const reportType = this.reportType();
            const calc = this.selectedReportTypeRequiresCalc() ? this.serializeCalc(this.reportCalcValues) : null;
            payload.report = {
                reportDurationPick: this.reportDurationPick(),
                taskDuration: this.taskDuration(),
                reportSort: Number(this.reportSort()),
                sendTime: (this.sendTime() || "").trim(),
                weekDayPick: this.weekDayPick(),
                workdayFirst: !!this.workday().first(),
                workdayLast: !!this.workday().last(),
                reportType,
                elementStatus: Number(this.elementStatus()),
                calc
            };
        }
        // Deadline
        if (type === 1) {
            payload.deadline = {
                sendTime: (this.sendTime() || "").trim(),
                elementStatus: Number(this.elementStatus()),
                calc: this.serializeCalc(this.deadlineCalcValues)
            };
        }
        // Appointment
        if (type === 2) {
            const dyn = this.appointmentDeliveryTimeType() === "2";

            payload.appointment = {
                bindPoint: this.reportBindPoint(),
                appointmentTypeId: this.appointmentTypesOfAppo() == null ? null : Number(this.appointmentTypesOfAppo()),
                status: Number(this.appointmentStatus()),
                deliveryTimeType: this.appointmentDeliveryTimeType(),
                sendTime: dyn ? null : (this.sendTime() || "").trim(),
                calc: this.serializeCalc(this.appointmentCalcValues)
            };
        }

        //  Backend call

        try {
            if (this.automationEditId() != null) {
                await RNSAPI.editAutomationTask(payload);
            } else {
                await RNSAPI.addAutomationTask(payload);
            }
            $("#automationModal").modal("hide");
            await this.getAllAutomationTasks();
            this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
            this.statusModalText(isEdit
                ? 'Die Automation wurde erfolgreich bearbeitet.'
                : 'Die Automation wurde erfolgreich angelegt.');
            $("#statusModal").modal('show');
        } catch (error) {
            this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler');
            this.statusModalText(isEdit
                ? 'Die Automation konnte nicht bearbeitet werden.'
                : 'Die Automation konnte nicht angelegt werden.');
            $("#statusModal").modal('show');
        }
    };
    async getAutomationReportTypes() {
        await RNSAPI.getAutomationReportTypes().then((response) => {
            const entries = ((response as any)?.Payload ?? response ?? []) as any[];
            const reportTypes = entries.map((entry) => ({
                id: String(entry.id ?? entry.Id),
                title: entry.title ?? entry.Title ?? "",
                short: entry.short ?? entry.Short ?? "",
                hasCalcStart: !!(entry.hasCalcStart ?? entry.HasCalcStart),
                hasCalcEnd: !!(entry.hasCalcEnd ?? entry.HasCalcEnd)
            }));
            this.automationReportTypeOptions(reportTypes);
            if (this.reportType() && !reportTypes.some(x => x.id === this.reportType())) {
                this.reportType("");
            }
        }).catch(() => {
            this.automationReportTypeOptions([]);
            this.reportType("");
        });
    }
    private setAutomationAppointmentTypeOptions(entries: any[]) {
        const options = (entries ?? []).map((entry) => ({
            id: Number(entry.Id ?? entry.id),
            title: entry.Name ?? entry.name ?? "",
            short: entry.TypeId ?? entry.typeId ?? "",
            inactive: !!(entry.Inactive ?? entry.inactive)
        }));
        this.automationAppointmentTypeOptions(options);

        const selectedId = this.appointmentTypesOfAppo();
        if (selectedId != null && !options.some(x => x.id === selectedId)) {
            this.appointmentTypesOfAppo(null);
        }
    }
    async getAllAutomationTasks() {
        await RNSAPI.getAutomationTasks(true).then((response) => {
            let tasks = ((response as any)?.Payload ?? response ?? []) as AutomationTaskResponse[];
            tasks = tasks.map((item) => this.normalizeAutomationTask(item)).map((a) => {
                a.title = a.title ?? "";
                a.automationTypeText = this.selectedAutomationTypeTextByValue(a.automationType);
                a.deliveryText = this.buildDeliveryTextForTask(a);
                a.isActiveText = a.isActive === false ? "Inaktiv" : "Aktiv";
                a.IsDeleted = a.isActive === false;
                a.actionHandlers = [
                    {
                        icon: "pencil-alt",
                        name: "Automation bearbeiten",
                        action: () => {
                            this.openEditAutomationModal(a);
                        }
                    },
                    {
                        icon: a.isActive === false ? "toggle-off" : "toggle-on",
                        name: a.isActive === false ? "Automation aktivieren" : "Automation deaktivieren",
                        action: () => {
                            this.setAutomationActivity(a, a.isActive === false);
                        }
                    }
                ];
                return a;
            });
            tasks = tasks.sort((a, b) => {
                if (!!a.isActive !== !!b.isActive) {
                    return a.isActive === false ? 1 : -1;
                }

                return (a.title || "").localeCompare(b.title || "", "de");
            });
            this.allAutomationTasks(tasks);
        }).catch((error) => { });
    }

    // #regionEnd Automation


    constructor(params: any) {
        this.referateStatus(true);
        this.weiderStatus(true);
        this.fristStatus(true);
        this.rachtsStatus(true);
        this.isLicenseExpired(RolesAndRights.isLicenseExpired());
        var user = RNSAPI.getCurrentLoggedInUser();
        if (ko.toJS(user.UseVerificationWorkflow) === "1")
            this.hasVerificationRights(true);
        if (ko.toJS(user.UseInboxWorkflow) === "1")
            this.hasInboxModule(true);
        if (ko.toJS(user.UseAutomation) === "1")
            this.hasAutomationModule(true);
        void this.loadLocationOptions();
        this.loadLawFirmAbonnementData();
        this.getKanzleiImage();
        this.getInstances();
        this.getFKA();
        this.getFristDeadlineReasons();
        this.getAllAutomationTasks();
        this.getAutomationReportTypes();
        this.getMailInboxes();
        this.getGerichte();
        this.getMakros();
        this.getDeadlineReasons();
        this.newCreateUser();
        this.inbox().EMail_Address.subscribe((newValue) => {
            if (this.inbox().IN_UserLogin() === "")
                this.inbox().IN_UserLogin(newValue);
            if (this.inbox().OUT_UserLogin() === "")
                this.inbox().OUT_UserLogin(newValue);
        });
        this.currentView = ko.observable(params.view);
        if (params.view == "showUsers") {
            this.currentView = ko.observable('profile');
        }
        else {
            this.currentView = ko.observable(params.view);
        }

        this.filteredInboxes = ko.computed({
            owner: this,
            read: () => {
                const inboxes = this.filterType() === 'bea' ? this.inboxes()
                    .filter(inbox => inbox.CertificatePin === 'B') :
                    this.inboxes()
                        .filter(inbox => !inbox.CertificatePin);
                return inboxes;
            }
        });
        this.update();
        this.getCurrentUserDetails();
        $('.menu>li a').removeClass('active');
        Postbox.publisher().subscribe(async (isVerified) => {
            if (isVerified)
                await this.executeSaveUserProfile();
        }, "VerifiedPassword");
        if (this.isLicenseExpired()) {
            this.showLicenseExpiredModal();
        }
        // Automation Part
        this.pageTitle = ko.pureComputed(() => {
            let tileString = "";
            if (!this.selectedAutomationTypeText())
                tileString = this.automationEditId() != null ? "Automation bearbeiten" : "Neue Automation";

            if (this.selectedAutomationTypeText())
                tileString = this.title() !== ""
                    ? (this.automationEditId() != null ? this.selectedAutomationTypeText() + " Automation bearbeiten - " + this.title() : "Neue " + this.selectedAutomationTypeText() + " Automation - " + this.title())
                    : (this.automationEditId() != null ? this.selectedAutomationTypeText() + " Automation bearbeiten" : "Neue " + this.selectedAutomationTypeText() + " Automation");

            return tileString;
        });
        this.appointmentCalcValues = new CalcViewModel({
            fromLabelText: "Versand",
            toLabelText: "Versand",

            bindPoint: this.reportBindPoint,
            showStartRow: ko.pureComputed(() => this.reportBindPoint() === "0"),
            reportStartAmount: this.appointmentStartAmount,
            reportStartInterval: this.appointmentStartInterval,
            reportStartMode: this.appointmentStartMode,
            showEndRow: ko.pureComputed(() => this.reportBindPoint() === "1"),
            reportEndAmount: this.appointmentEndAmount,
            reportEndInterval: this.appointmentEndInterval,
            reportEndMode: this.appointmentEndMode,

            intervalOptions: this.appointmentIntervalOptions,
            startModeOptions: this.appointmentStartModeOptions,
            endModeOptions: this.appointmentEndModeOptions,

            refDatePlaceholder: "Termin-Datum",
            refDateText: this.appointmentRefDateText,

            amountIntervalEnabled: this.appointmentAmountIntervalEnabled,
            modeEnabled: this.appointmentModeEnabled
        });
        this.deadlineCalcValues = new CalcViewModel({
            fromLabelText: "Versand",
            toLabelText: "Versand",

            bindPoint: this.reportBindPoint,
            showStartRow:  ko.observable(true),
            reportStartAmount: this.deadlineStartAmount,
            reportStartInterval: this.deadlineStartInterval,
            reportStartMode: this.deadlineStartMode,
            reportEndAmount: ko.observable(""),
            reportEndInterval: ko.observable(-1),
            reportEndMode: ko.observable(0),
            showEndRow: ko.observable(false),

            intervalOptions: this.deadlineIntervalOptions,
            startModeOptions: this.deadlineStartModeOptions,
            endModeOptions: this.deadlineStartModeOptions,

            refDatePlaceholder: "Frist-Datum",
            refDateText: this.deadlineRefDateText,

            amountIntervalEnabled: this.deadlineAmountIntervalEnabled,
            modeEnabled: this.deadlineModeEnabled
        });
        this.reportCalcValues = new CalcViewModel({
            fromLabelText: "Von",
            toLabelText: "Bis",

            bindPoint: this.reportBindPoint,
            showStartRow: ko.pureComputed(() => {
                return this.selectedReportType()?.hasCalcStart ?? false;
            }),
            reportStartAmount: this.appointmentStartAmount,
            reportStartInterval: this.appointmentStartInterval,
            reportStartMode: this.appointmentStartMode,
            reportEndAmount: this.appointmentEndAmount,
            reportEndInterval: this.appointmentEndInterval,
            reportEndMode: this.appointmentEndMode,
            showEndRow: ko.pureComputed(() => {
                return this.selectedReportType()?.hasCalcEnd ?? false;
            }),
            intervalOptions: this.appointmentIntervalOptions,
            startModeOptions: this.appointmentStartModeOptions,
            endModeOptions: this.appointmentEndModeOptions,
            refDatePlaceholder: "Termin-Datum",
            refDateText: this.reportsRefDateText,
            amountIntervalEnabled: this.deadlineAmountIntervalEnabled,
            modeEnabled: this.deadlineModeEnabled
        });
        this.currentAutoPage.subscribe(page => {
            if (page === "Report") {
                this.updateReportSortOptions();
                this.reportDurationPickSub?.dispose();
                this.reportDurationPickSub = this.reportDurationPick.subscribe(() => {
                    this.updateReportSortOptions();
                });
            } else {
                this.reportDurationPickSub?.dispose();
                this.reportDurationPickSub = undefined;
            }
        });
        this.updateSendTime();
        this.appointmentRefDateText("Termin");
        this.deadlineRefDateText("Frist");
        this.reportsRefDateText("Versandzeitpunkt");
        this.reportBindPoint.subscribe(v => {
            if (v === "0") {
                // End reset
                this.appointmentEndAmount("");
                this.appointmentEndInterval(-1);
                this.appointmentEndMode(0);
            } else {
                // Start reset
                this.appointmentStartAmount("");
                this.appointmentStartInterval(-1);
                this.appointmentStartMode(0);
            }
        });
        this.appointmentDeliveryTimeType.subscribe(v => {
            this.automationValidationMessage("");
            this.showErrorTime(false);
            if (v === "2") this.sendTime(""); // dynamisch -> keine Uhrzeit
        });
        this.reportDurationPick.subscribe(() => {
            this.automationValidationMessage("");
            this.showAmountError(false);
        });
        this.reportSort.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.weekDayPick.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.sendMailToAll.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.additionalMailRecipient.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.sendTime.subscribe(() => {
            this.automationValidationMessage("");
            this.showErrorTime(false);
        });
        this.reportType.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.saveToDirectory.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.directoryPath.subscribe(() => {
            this.automationValidationMessage("");
        });
        this.registerAutomationModalReset();
    }
    private selectedAutomationTypeTextByValue(value: number | string | null | undefined): string {
        switch (Number(value)) {
            case 0: return "Auswertung";
            case 1: return "Frist";
            case 2: return "Termin";
            default: return "";
        }
    }
    async showLicenseExpiredModal() {
        try {
            setTimeout(() => { $("#LicenseExpired").modal('show'); }, 1000);
        }
        catch {
        }
    }
    async verifyPassword() {
        this.passwordError("");
        if (this.userPassword() === '' || !this.userPassword())
            return this.passwordError("Bitte geben Sie ihr Anmeldepasswort ein.");
        this.executeSaveUserProfile();
    }

    private async executeSaveUserProfile() {
        this.executeSaveUserProfileLoader(true);
        await RNSAPI.updateUserData(this.convertLawFirmDataToBackendObject()).then((data) => {
            this.handleUpdateUserDataResponse('Erfolgreich gespeichert.', false);
        }).catch((error) => {
            this.handleUpdateUserDataResponse('Benutzeraktualisierung war nicht erfolgreich.', true);
        });
    }

    private handleUpdateUserDataResponse(text: string, hasError: boolean) {
        $("#VerifyPasswordDialogExt").modal('hide');
        this.executeSaveUserProfileLoader(false);
        this.statusText(text);
        this.hasError(hasError);
        this.statusVisible(true);
    }
}

type KOComp<T> = ReturnType<typeof ko.pureComputed<T>>;
type KO<T> = ReturnType<typeof ko.observable<T>>;
type KOAny<T> = KO<T> | KOComp<T>;
type SummaryCalcRow = {
    label: string;
    amount: string;
    intervalText: string;
    modeText: string;
};
type SummaryCalc = {
    refDatePlaceholder: string;
    refDateText: string;
    start?: SummaryCalcRow | null;
    end?: SummaryCalcRow | null;
};
type MailSummary = {
    sendMailToAll: boolean;
    additionalMailRecipient: string;
    saveToDirectory: boolean;
    directoryPath: string;
    locationText: string;
};
type HeaderSummary = {
    title: string;
    note: string;
    automationTypeText: string;
    applyToAllText: string;
};
type ReportSummary = {
    frequencyPick: string;
    taskDuration: number | null;
    reportSort: number;
    sendTime: string;
    weekDayPick: number | null;
    workdayFirst: boolean;
    workdayLast: boolean;
    reportType: string;
    elementStatus: number;
    calc: SummaryCalc | null;

    deliveryText: string;
    typeText: string;
    statusText: string;
    reportSortText: string;
    frequencyText: string;
    weekDayText: string;
    workdayText: string;
    periodText: string;
};
type DeadlineSummary = {
    sendTime: string;
    elementStatus: number;
    statusText: string;
    deliveryText: string;
};
type AppointmentSummary = {
    deliveryTimeType: string;
    deliveryTimeTypeText: string;
    typesOfAppo: number;
    typesText: string;
    status: number;
    statusText: string;
    sendTime: string;      // nur bei Individuell gefüllt
    bindPoint: string;
    bindPointText: string;
    calc: SummaryCalc;
    periodText: string;
};
type AutomationSummaryDto = {
    header: HeaderSummary;
    type: number | null;
    mail: MailSummary;
    report: ReportSummary | null;
    deadline: DeadlineSummary | null;
    appointment: AppointmentSummary | null;
};
type CalcDto = {
    start?: { amount: number | null; interval: number; mode: number } | null;
    end?: { amount: number | null; interval: number; mode: number } | null;
};
type AutomationPayload = {
    id?: number;
    title: string;
    note: string;
    automationType: number;
    sendMailToAll: boolean;
    additionalMailRecipient: string;
    applyToAll?: boolean | null;
    saveToDirectory: boolean;
    directoryPath: string;
    locationIds: number[];
    report?: {
        reportDurationPick: string;
        taskDuration: number | null;
        reportSort: number;
        sendTime: string;
        weekDayPick: number | null;
        workdayFirst: boolean;
        workdayLast: boolean;
        reportType: string;
        elementStatus: number;
        calc: CalcDto | null;
    };
    deadline?: {
        sendTime: string;
        elementStatus: number;
        calc: CalcDto;
    };
    appointment?: {
        bindPoint: string;
        appointmentTypeId: number | null;
        status: number;
        deliveryTimeType: string;
        sendTime?: string | null;
        calc: CalcDto;
    };
};
type AutomationCalcResponse = {
    start?: { amount: number | null; interval: number; mode: number } | null;
    end?: { amount: number | null; interval: number; mode: number } | null;
};
type AutomationTaskResponse = {
    id?: number;
    title: string;
    note: string;
    automationType: number;
    sendMailToAll: boolean;
    additionalMailRecipient: string;
    applyToAll?: boolean | null;
    isActive?: boolean;
    saveToDirectory?: boolean;
    directoryPath?: string | null;
    locationIds?: number[];
    report?: {
        reportDurationPick?: string;
        taskDuration?: number | null;
        reportSort?: number;
        sendTime?: string;
        weekDayPick?: number | null;
        workdayFirst?: boolean;
        workdayLast?: boolean;
        reportType?: string;
        elementStatus?: number;
        calc?: AutomationCalcResponse | null;
    } | null;
    deadline?: {
        sendTime?: string;
        elementStatus?: number;
        calc?: AutomationCalcResponse | null;
    } | null;
    appointment?: {
        bindPoint?: string;
        appointmentTypeId?: number;
        status?: number;
        deliveryTimeType?: string;
        sendTime?: string | null;
        calc?: AutomationCalcResponse | null;
    } | null;
    automationTypeText?: string;
    deliveryText?: string;
    isActiveText?: string;
    IsDeleted?: boolean;
    actionHandlers?: any[];
};
type AutomationReportTypeOption = {
    id: string;
    title: string;
    short: string;
    hasCalcStart: boolean;
    hasCalcEnd: boolean;
};
type AutomationAppointmentTypeOption = {
    id: number;
    title: string;
    short: string;
    inactive: boolean;
};
export type IntervalOption = {
    text: string;
    reportIntervalValues: number;
};
export type ModeOption = {
    text: string;
    reportModeValues: number;
};
interface CalcViewModelParams{
    // Labels
    fromLabelText: string;
    toLabelText: string;

    // Start-Bindings
    reportStartAmount: KO<string | number>;
    reportStartInterval: KO<number>;
    reportStartMode: KO<number>;
    showStartRow?: KOAny<boolean>;

    // End-Bindings
    reportEndAmount: KO<string | number>;
    reportEndInterval: KO<number>;
    reportEndMode: KO<number>;
    showEndRow?: KOAny<boolean>;

    intervalOptions: IntervalOption[];
    startModeOptions: ModeOption[];
    endModeOptions: ModeOption[];
    intervalCaption?: string;

    refDatePlaceholder: string;
    refDateText?: KO<string>;

    modeEnabled?: KO<boolean>;
    amountIntervalEnabled?: KO<boolean>;
    bindPoint: KO<string>;
}
export class CalcViewModel {
    fromLabelText: KO<string>;
    toLabelText: KO<string>;
    bindPoint: KO<string>;
    showStartRow:KOAny<boolean>;
    showEndRow:KOAny<boolean>;
    reportStartAmount: KO<string | number>;
    reportStartInterval: KO<number>;
    reportStartMode: KO<number>;
    reportEndAmount: KO<string | number>;
    reportEndInterval: KO<number>;
    reportEndMode: KO<number>;
    startAmountIntervalEnabled: ReturnType<typeof ko.pureComputed<boolean>>;
    endAmountIntervalEnabled: ReturnType<typeof ko.pureComputed<boolean>>;
    intervalOptions: IntervalOption[];
    startModeOptions: ModeOption[];
    endModeOptions: ModeOption[];
    intervalCaption: string;
    refDatePlaceholder: string;
    refDateText: KO<string>;
    modeEnabled: KO<boolean>;
    amountIntervalEnabled: KO<boolean>;

    private toSummaryCalc(calc: CalcViewModel): SummaryCalc {
        const intervalText = (val: number) =>
            calc.intervalOptions.find(x => x.reportIntervalValues === val)?.text ?? "";
        const modeText = (opts: ModeOption[], val: number) =>
            opts.find(x => x.reportModeValues === val)?.text ?? "";
        const start = calc.showStartRow() ? {
                label: calc.fromLabelText(),
                amount: String(calc.reportStartAmount() ?? ""),
                intervalText: intervalText(Number(calc.reportStartInterval())),
                modeText: modeText(calc.startModeOptions, Number(calc.reportStartMode())) }
            : null;
        const end = calc.showEndRow() ? {
                label: calc.toLabelText(),
                amount: String(calc.reportEndAmount() ?? ""),
                intervalText: intervalText(Number(calc.reportEndInterval())),
                modeText: modeText(calc.endModeOptions, Number(calc.reportEndMode()))}
            : null;
        return { refDateText: calc.refDateText?.() ?? "", refDatePlaceholder: calc.refDatePlaceholder ?? "", start, end};
    }

    constructor(p: CalcViewModelParams) {
        this.fromLabelText = ko.observable(p.fromLabelText);
        this.toLabelText = ko.observable(p.toLabelText);

        this.reportStartAmount = p.reportStartAmount;
        this.reportStartInterval = p.reportStartInterval;
        this.reportStartMode = p.reportStartMode;
        this.showStartRow = p.showStartRow ?? ko.observable(true);

        this.reportEndAmount = p.reportEndAmount;
        this.reportEndInterval = p.reportEndInterval;
        this.reportEndMode = p.reportEndMode;
        this.showEndRow = p.showEndRow ?? ko.observable(true);

        this.intervalOptions = p.intervalOptions;
        this.startModeOptions = p.startModeOptions;
        this.endModeOptions = p.endModeOptions;
        this.intervalCaption = p.intervalCaption ?? "";

        this.refDatePlaceholder = p.refDatePlaceholder;
        this.refDateText = p.refDateText ?? ko.observable("");

        this.modeEnabled = p.modeEnabled ?? ko.observable(false);
        this.amountIntervalEnabled = p.amountIntervalEnabled ?? ko.observable(false);
        this.bindPoint = p.bindPoint;

        const isAt = (mode: any) => Number(mode) === 0;
        this.startAmountIntervalEnabled = ko.pureComputed(() => Number(this.reportStartMode()) !== 0);
        this.endAmountIntervalEnabled   = ko.pureComputed(() => Number(this.reportEndMode()) !== 0);
        this.reportStartMode.subscribe(m => {
            if (isAt(m)) {
                this.reportStartAmount("");
                this.reportStartInterval(-1)
            }
        });
        this.reportEndMode.subscribe(m => {
            if (isAt(m)) {
                this.reportEndAmount("");
                this.reportEndInterval(-1);
            }
        });
    }
}

let html = fs.readFileSync(__dirname + '/overview.html', 'utf8');
ko.components.register("settings-view", {
    viewModel: SettingsViewModel,
    template: html
});







